{
  "workspace.a11y.skipToMain": "Skip to main content",
  "workspace.activation.blockedBody": "{loaded} of {total} apps are ready. {blocked} cannot load in this workspace. Republish the app or remove it — a retry gives the same result.",
  "workspace.activation.blockedTitle": "Some apps cannot load",
  "workspace.activation.errorBody": "Retry to load what is missing. Your loaded content will be kept.",
  "workspace.activation.errorTitle": "Some workspace content couldn’t load",
  "workspace.activation.partialBody": "{loaded} of {total} apps are ready. Retry to load the rest.",
  "workspace.activation.partialTitle": "Some apps couldn’t load",
  "workspace.activation.retry": "Retry loading",
  "workspace.activation.retrying": "Retrying…",
  "workspace.activation.retryingBody": "Keeping your loaded content while we try again.",
  "workspace.activation.retryingTitle": "Retrying workspace loading",
  "workspace.activation.slowBody": "Apps and saved preferences are still loading. You can use available content or retry.",
  "workspace.activation.slowTitle": "Workspace is still loading",
  "workspace.addApp.apps.yours": "Your apps",
  "workspace.addApp.balance.available": "{count} credits available",
  "workspace.addApp.balance.allowance": "Monthly allowance: {remaining} of {total} left.",
  "workspace.addApp.balance.purchased": "Purchased credits: {count}.",
  "workspace.addApp.crmLeads.toggle": "Send sign-ups to CRM",
  "workspace.addApp.crmLeads.on": "New sign-ups go to your CRM",
  "workspace.addApp.crmLeads.noCrm": "Install the CRM app to receive sign-ups as leads",
  "workspace.addApp.crmLeads.noForm": "This app has no sign-up form",
  "workspace.addApp.crmLeads.saveError": "Could not change the CRM setting. Try again.",
  "workspace.addApp.estimate.free": "Your first build is free.",
  "workspace.addApp.estimate.step": "This first step costs about {count} credits.",
  "workspace.addApp.apps.emptyPrivate": "No private apps yet",
  "workspace.addApp.apps.emptyPrivateLine": "Describe one in the chat. Once you save it, it shows up here.",
  "workspace.addApp.apps.emptyShared": "Nothing shared yet",
  "workspace.addApp.apps.emptySharedLine": "Share an app and everyone in this workspace can use it.",
  "workspace.addApp.chat.newApp": "New app",
  "workspace.addApp.canvas.failedHint": "The build stopped before there was an app to show. The conversation says what went wrong — ask there to try again.",
  "workspace.addApp.canvas.failedTitle": "This app could not be built",
  "workspace.addApp.canvas.hint": "Your app will appear here as you build. Keep the conversation going to refine it.",
  "workspace.addApp.canvas.title": "Your idea is taking shape",
  "workspace.addApp.catalog.title": "Ready-made apps",
  "workspace.addApp.chat.hint": "What would you like to build?",
  "workspace.addApp.chat.sub": "Turn an idea into an app for your workspace. Describe what you need, and build it together.",
  "workspace.addApp.chat.starter1": "Build a kanban board for my tasks grouped by assignee",
  "workspace.addApp.chat.starter2": "Add a dashboard of this week’s meetings",
  "workspace.addApp.chat.starter3": "Make a directory of everyone on the workspace",
  "workspace.addApp.chat.starter4": "Create a notes board wired to my documents",
  "workspace.addApp.install.add": "Add to Workspace",
  "workspace.addApp.install.added": "Added to workspace",
  "workspace.addApp.install.checking": "Checking workspace...",
  "workspace.addApp.installed.remove": "Remove",
  "workspace.addApp.installed.title": "Installed apps",
  "workspace.addApp.installed.appFallback": "App",
  "workspace.addApp.link.docs": "Build a custom app — docs",
  "workspace.addApp.link.manage": "Manage installed app",
  "workspace.addApp.link.marketplace": "Browse all in the App Store",
  "workspace.addApp.page.title": "Add app · Symbols.app",
  "workspace.addApp.removeApp": "Remove app",
  "workspace.addApp.resetNavbar": "Reset navbar",
  "workspace.addApp.save": "Save",
  "workspace.addApp.scope.private": "Private",
  "workspace.addApp.scope.shared": "Shared",
  "workspace.addApp.scope.title": "Visibility",
  "workspace.addApp.share": "Share",
  "workspace.addApp.share.body": "“{name}” will become visible and installable to everyone in this workspace. You can keep it private instead.",
  "workspace.addApp.share.confirm": "Share with everyone",
  "workspace.addApp.share.keepPrivate": "Keep private",
  "workspace.addApp.share.thisExtension": "This app",
  "workspace.addApp.share.title": "Share with the workspace?",
  "workspace.addApp.save.buildFirst": "Build an app first.",
  "workspace.addApp.saveError.cannotCreate": "Cannot create a new app here.",
  "workspace.addApp.saveError.noWorkspace": "No active workspace.",
  "workspace.addApp.saveError.nothingToSave": "Nothing to save — build an app first.",
  "workspace.addApp.saveError.storeUnavailable": "Saving apps is not available right now.",
  "workspace.addApp.save.failed": "Save failed: {reason}",
  "workspace.addApp.save.nothingHere": "Nothing to save here.",
  "workspace.addApp.save.savedAsApp": "Saved “{name}” as an app.",
  "workspace.addApp.save.savedPrivate": "Saved to your private apps.",
  "workspace.addApp.save.savedShared": "Saved. Everyone in this workspace can still open it.",
  "workspace.addApp.save.openApp": "Open {name}",
  "workspace.addApp.save.sharedAll": "Shared with everyone in this workspace.",
  "workspace.addApp.unbackedNotice": "Preview only — “{names}” has no data store yet, so records won’t save until one is added.",
  "workspace.addApp.extensionFallback": "Untitled app",
  "workspace.addApp.installOwn": "Install your own",
  "workspace.addApp.installingOwn": "Installing…",
  "workspace.addApp.error.buildFailed": "build failed",
  "workspace.agents.assignedToYou": "{count} agents assigned to you",
  "workspace.agents.assignedToYouOne": "1 agent assigned to you",
  "workspace.agents.available": "Available",
  "workspace.agents.caption": "Agent",
  "workspace.agents.checking": "Checking your agents…",
  "workspace.agents.countInWorkspace": "{count} agents in this workspace",
  "workspace.agents.countInWorkspaceOne": "1 agent in this workspace",
  "workspace.agents.createCaption": "Spin up a new AI agent",
  "workspace.agents.createFirst": "Create your first agent",
  "workspace.agents.createTitle": "Create agent",
  "workspace.agents.fallbackName": "Agent",
  "workspace.agents.loadFailed": "Couldn't load your agents",
  "workspace.agents.loadFailedShort": "Couldn’t load agents",
  "workspace.agents.membersLoadFailed": "Couldn’t load members",
  "workspace.agents.none": "No agents yet",
  "workspace.agents.role.admin": "Admin",
  "workspace.agents.role.adminHint": "Full control — content plus team + assignment management.",
  "workspace.agents.role.editor": "Editor",
  "workspace.agents.role.editorHint": "Can view and create content — tickets, docs, messages.",
  "workspace.agents.role.guest": "Guest",
  "workspace.agents.role.guestHint": "Read-only — can view workspace content, never writes.",
  "workspace.agents.scope.wholeWorkspace": "Whole workspace",
  "workspace.agents.untitledProject": "Untitled project",
  "workspace.ai.action.createEvent": "Create Event",
  "workspace.ai.action.createKb": "Create KB Article",
  "workspace.ai.action.createNote": "Create Note",
  "workspace.ai.action.createTicket": "Create Task",
  "workspace.ai.action.moveTicket": "Move Task",
  "workspace.ai.action.updateTicket": "Update Task",
  "workspace.ai.approvalPrompt": "I need your approval before I make this change:",
  "workspace.ai.awaitingApproval": "Awaiting human approval.",
  "workspace.ai.emptyHint": "Ask me about documents, team, calendar, or tickets.",
  "workspace.ai.newRecord.article": "New article",
  "workspace.ai.newRecord.event": "New event",
  "workspace.ai.newRecord.note": "New note",
  "workspace.ai.newRecord.ticket": "New ticket",
  "workspace.ai.newRecord.category": "General",
  "workspace.ai.suggest.approvals": "What is pending approval?",
  "workspace.ai.suggest.documents": "Show me company documents",
  "workspace.ai.suggest.events": "What events are coming up?",
  "workspace.ai.suggest.tasks": "What tasks are open?",
  "workspace.ai.suggest.team": "Who is on the team?",
  "workspace.ai.actionCancelled": "No problem — I’ve cancelled that. Nothing was changed.",
  "workspace.ai.actionDone": "Done.",
  "workspace.ai.actionFailed": "Action failed.",
  "workspace.ai.actionNotApplied": "That change could not be applied — nothing was modified.",
  "workspace.ai.noWorkspaceUi": "No workspace UI available.",
  "workspace.ai.nothingToApprove": "Nothing to approve.",
  "workspace.ai.reply.connectionError": "Connection error — please try again.",
  "workspace.ai.reply.empty": "Sorry, I could not generate a response.",
  "workspace.ai.unknownAction": "Unknown action \"{action}\".",
  "workspace.aiDecisions.untitled": "(untitled decision)",
  "workspace.aiDecisions.needed": "{count} decisions needed",
  "workspace.aiDecisions.neededOne": "1 decision needed",
  "workspace.aiStarter.app.whatsNew": "{app}: what is new?",
  "workspace.aiStarter.app.whatsNewPrompt": "{app}: summarize the recent activity and changes.",
  "workspace.aiStarter.apps.installed": "Which apps does {workspace} use?",
  "workspace.aiStarter.apps.installedPrompt": "List the apps installed in this workspace and what each one is for.",
  "workspace.aiStarter.chat.missed": "What did I miss in Chat?",
  "workspace.aiStarter.chat.missedPrompt": "Summarize the unread messages across our chat channels.",
  "workspace.aiStarter.files.recent": "What was added to Files this week?",
  "workspace.aiStarter.files.recentPrompt": "List the files added or changed this week.",
  "workspace.aiStarter.infra.status": "How are our services doing?",
  "workspace.aiStarter.infra.statusPrompt": "Report the status of our infrastructure and any open incidents.",
  "workspace.aiStarter.mail.unread": "Summarize my unread mail",
  "workspace.aiStarter.mail.unreadPrompt": "Summarize my unread mail and point out anything urgent.",
  "workspace.aiStarter.meet.last": "Summarize our last meeting",
  "workspace.aiStarter.meet.lastPrompt": "Summarize our last meeting and its action items.",
  "workspace.aiStarter.notes.recent": "What changed in Notes this week?",
  "workspace.aiStarter.notes.recentPrompt": "Summarize the notes created or changed this week.",
  "workspace.aiStarter.people.who": "Who is on {workspace}?",
  "workspace.aiStarter.people.whoPrompt": "List the members of this workspace and their roles.",
  "workspace.aiSuggest.agent.access": "Review access",
  "workspace.aiSuggest.agent.accessPrompt": "Review this agent's capabilities and access.",
  "workspace.aiSuggest.agent.refine": "Refine instructions",
  "workspace.aiSuggest.agent.refinePrompt": "Suggest improvements to this agent's instructions.",
  "workspace.aiSuggest.announcement.draftReply": "Draft a reply",
  "workspace.aiSuggest.announcement.draftReplyPrompt": "Help me draft a reply to this announcement.",
  "workspace.aiSuggest.announcement.summarize": "Summarize",
  "workspace.aiSuggest.announcement.summarizePrompt": "Summarize this announcement.",
  "workspace.aiSuggest.calendar.agenda": "Today's agenda",
  "workspace.aiSuggest.calendar.agendaPrompt": "Summarize what's on my calendar today.",
  "workspace.aiSuggest.calendar.schedule": "Schedule an event",
  "workspace.aiSuggest.calendar.schedulePrompt": "Schedule a new event.",
  "workspace.aiSuggest.chat.catchUp": "Catch me up",
  "workspace.aiSuggest.chat.catchUpPrompt": "Summarize the unread messages in this channel.",
  "workspace.aiSuggest.createAgent.setup": "Suggest a setup",
  "workspace.aiSuggest.createAgent.setupPrompt": "Suggest a name, role, and instructions for this new agent.",
  "workspace.aiSuggest.createMember.who": "Who to invite?",
  "workspace.aiSuggest.createMember.whoPrompt": "Suggest who to invite and with what role.",
  "workspace.aiSuggest.document.grammar": "Fix grammar",
  "workspace.aiSuggest.document.grammarPrompt": "Fix the grammar and spelling in this document.",
  "workspace.aiSuggest.document.improve": "Improve writing",
  "workspace.aiSuggest.document.improvePrompt": "Improve the clarity and flow of this document.",
  "workspace.aiSuggest.document.summarize": "Summarize",
  "workspace.aiSuggest.document.summarizePrompt": "Summarize this document.",
  "workspace.aiSuggest.event.reschedule": "Reschedule",
  "workspace.aiSuggest.event.reschedulePrompt": "Reschedule this event to a new time.",
  "workspace.aiSuggest.event.summarize": "Summarize",
  "workspace.aiSuggest.event.summarizePrompt": "Summarize this event and its details.",
  "workspace.aiSuggest.generic.myPlate": "What's on my plate?",
  "workspace.aiSuggest.generic.myPlatePrompt": "List my open tasks, upcoming events and recent mentions.",
  "workspace.aiSuggest.generic.whatCanYouDo": "What can you do here?",
  "workspace.aiSuggest.generic.whatCanYouDoPrompt": "What can you help me with on this page?",
  "workspace.aiSuggest.notes.create": "New note",
  "workspace.aiSuggest.notes.createPrompt": "Create a new note.",
  "workspace.aiSuggest.person.draftMessage": "Draft a message",
  "workspace.aiSuggest.person.draftMessagePrompt": "Help me draft a message to this person.",
  "workspace.aiSuggest.person.summarize": "Summarize",
  "workspace.aiSuggest.person.summarizePrompt": "Summarize this person's role and recent activity.",
  "workspace.aiSuggest.record.inviteMember": "Invite member",
  "workspace.aiSuggest.record.newAgent": "New agent",
  "workspace.aiSuggest.record.untitledNote": "Untitled note",
  "workspace.aiSuggest.tasks.blocked": "What's blocked?",
  "workspace.aiSuggest.tasks.blockedPrompt": "Which tasks are blocked or overdue?",
  "workspace.aiSuggest.tasks.board": "Summarize the board",
  "workspace.aiSuggest.tasks.boardPrompt": "Summarize the current state of the board.",
  "workspace.aiSuggest.tasks.create": "Create a task",
  "workspace.aiSuggest.tasks.createPrompt": "Create a new task.",
  "workspace.aiSuggest.teamMember.summarize": "Summarize",
  "workspace.aiSuggest.teamMember.summarizePrompt": "Summarize this team member's role and work.",
  "workspace.aiSuggest.ticket.reassign": "Reassign",
  "workspace.aiSuggest.ticket.reassignPrompt": "Reassign this ticket to a teammate.",
  "workspace.aiSuggest.ticket.status": "Change status",
  "workspace.aiSuggest.ticket.statusPrompt": "Move this ticket to a different status.",
  "workspace.aiSuggest.ticket.subtasks": "Break into subtasks",
  "workspace.aiSuggest.ticket.subtasksPrompt": "Break this ticket down into subtasks.",
  "workspace.aiSuggest.ticket.summarize": "Summarize",
  "workspace.aiSuggest.ticket.summarizePrompt": "Summarize this ticket and its discussion.",
  "workspace.aiWidget.empty": "Nothing to show yet",
  "workspace.announcements.addReaction": "Add reaction",
  "workspace.announcements.audience": "Audience",
  "workspace.announcements.audienceAria": "News audience",
  "workspace.announcements.clearFilters": "Clear search and topic",
  "workspace.announcements.closeLabel": "Close announcement",
  "workspace.announcements.description": "Write a clear update once, then keep team news and public releases in their own lanes.",
  "workspace.announcements.empty.allTitle": "No announcements yet",
  "workspace.announcements.empty.filteredCopy": "Try a different search or clear the topic filter.",
  "workspace.announcements.empty.filteredTitle": "No matching updates",
  "workspace.announcements.empty.publicTitle": "No public releases yet",
  "workspace.announcements.empty.publisherCopy": "Share a clear update with your audience.",
  "workspace.announcements.empty.readerCopy": "When your team publishes, new updates will appear here.",
  "workspace.announcements.empty.teamTitle": "No team updates yet",
  "workspace.announcements.eyebrow": "Newsroom",
  "workspace.announcements.loadFailed": "Announcements could not be loaded",
  "workspace.announcements.navAria": "Announcements filters",
  "workspace.announcements.page.title": "Announcements",
  "workspace.announcements.scope.all": "All",
  "workspace.announcements.scope.public": "Public",
  "workspace.announcements.scope.team": "Team",
  "workspace.announcements.search": "Search news…",
  "workspace.announcements.searchAria": "Search announcements",
  "workspace.announcements.showMore": "Show more",
  "workspace.announcements.title": "Announcements",
  "workspace.announcements.topics": "Topics",
  "workspace.announcements.tryAgain": "Try again to load the latest updates.",
  "workspace.announcements.updateCount": "{count} updates",
  "workspace.announcements.writeRelease": "Write release",
  "workspace.answer.more": "{n} of {total} shown",
  "workspace.answer.moreOpen": "The first {n} — the rest are in the app",
  "workspace.apps.addConfirm": "Add to workspace?",
  "workspace.apps.addConfirmBody": "“{app}” becomes available to everyone in this workspace — shared, with its own tab in the navbar and launcher.",
  "workspace.apps.addCta": "Add to workspace",
  "workspace.apps.addFailed": "Add to workspace failed",
  "workspace.apps.added": "{app} added to the workspace",
  "workspace.apps.addedBody": "Everyone here can open it from the navbar.",
  "workspace.apps.alreadyAdded": "{app} is already in this workspace",
  "workspace.apps.cantAddYet": "Can’t add to the workspace yet",
  "workspace.apps.cantInstallYet": "Can’t install yet",
  "workspace.apps.cantRemoveYet": "Can’t remove the app yet",
  "workspace.apps.cantResetYet": "Can’t reset the navbar yet",
  "workspace.apps.crmLeads.visitorLine": "Your details go to our team so we can contact you.",
  "workspace.apps.installFailed": "Install failed",
  "workspace.apps.installFailedBody": "The server rejected the app reference.",
  "workspace.apps.installed": "{app} installed — Open",
  "workspace.apps.installedBody": "Its pages and widgets are live for this workspace.",
  "workspace.apps.loadFailed": "App couldn’t load",
  "workspace.apps.opening": "Opening {app}…",
  "workspace.apps.missingRef": "Missing app reference",
  "workspace.apps.missingRefBody": "Owner and key are required.",
  "workspace.apps.navbarReset": "Navbar reset",
  "workspace.apps.noAppInstalled": "No app installed",
  "workspace.apps.noAppSelected": "No app selected",
  "workspace.apps.noWorkspace": "No active workspace",
  "workspace.apps.pageMissing": "Page not available",
  "workspace.apps.pageMissingBody": "\"{page}\" isn’t installed in this workspace.",
  "workspace.apps.removeConfirm": "Remove app?",
  "workspace.apps.removeConfirmBody": "This removes {app}'s pages, widgets and navbar entries from this workspace. Your content stays and reappears if you reinstall.",
  "workspace.apps.removeCta": "Remove app",
  "workspace.apps.removeFailed": "Remove failed",
  "workspace.apps.removed": "{app} removed",
  "workspace.apps.removedBody": "Your content stays and reappears if you reinstall.",
  "workspace.apps.resetFailed": "Reset failed",
  "workspace.apps.resetNavbarConfirm": "Reset navbar?",
  "workspace.apps.resetNavbarConfirmBody": "Restores the default Apps · Tasks · Files tabs and drops any customization or app-added entries.",
  "workspace.apps.resetNavbarCta": "Reset navbar",
  "workspace.apps.saveFirst": "Save the app first",
  "workspace.apps.saveFirstBody": "Only saved apps can be added to the workspace.",
  "workspace.apps.serverRejected": "The server rejected the request.",
  "workspace.apps.stillLoading": "Workspace still loading",
  "workspace.apps.stillLoadingBody": "This workspace’s settings haven’t finished loading yet — try again in a moment.",
  "workspace.apps.nameFallback": "App",
  "workspace.launcher.filterPlaceholder": "Filter apps",
  "workspace.launcher.noMatches": "No matches",
  "workspace.appBlocked.heading": "This app uses a blocked feature",
  "workspace.appBlocked.hint": "For your safety, this app does not run. Ask the AI to rebuild it with the allowed features.",
  "workspace.appBlocked.rebuild": "Ask AI to rebuild",
  "workspace.appBlocked.rebuildPrompt": "Rebuild the app {name} so it uses only the allowed app features. The workspace blocked it for: {reasons}",
  "workspace.assistant.close": "Close assistant",
  "workspace.assistant.dock.left": "Dock left",
  "workspace.assistant.dock.right": "Dock right",
  "workspace.assistant.minimize": "Minimize to a chip above the composer",
  "workspace.assistant.ticketNotice.done": "{ticket} just **shipped**{commit}. [View ticket →]({href})",
  "workspace.assistant.ticketNotice.awaitingApproval": "{ticket} is **awaiting your approval**{commit}. [View ticket →]({href})",
  "workspace.assistant.ticketNotice.started": "{ticket} just **started**{commit}. [View ticket →]({href})",
  "workspace.assistant.ticketNotice.titled": "Your ticket \"{title}\"",
  "workspace.assistant.ticketNotice.numbered": "Your ticket #{id}",
  "workspace.assistant.ticketNotice.commit": " (commit `{sha}`)",
  "workspace.assistant.threadFallback": "Thread",
  "workspace.assistant.openInMain": "Open in main",
  "workspace.assistant.resize": "Resize the assistant",
  "workspace.askRoute.toPages": "Making a page for this",
  "workspace.askRoute.toSlides": "Making slides for this",
  "workspace.askRoute.toApp": "Building an app for this",
  "workspace.askRoute.toSite": "Building a website for this",
  "workspace.askRoute.toChat": "Answering in chat",
  "workspace.askRoute.backToChat": "Back to chat",
  "workspace.askRoute.backToPages": "Back to pages",
  "workspace.askRoute.backToHome": "Back to home",
  "workspace.askRoute.pagesUnavailable": "Pages are not available here yet — I’ll answer in this chat.",
  "workspace.askRoute.slidesUnavailable": "Slides are not available here yet — I’ll answer in this chat.",
  "workspace.assistantBoard.region": "Generated board",
  "workspace.assistantBoard.micro": "Generated · {count} widgets · {when}",
  "workspace.assistantBoard.microOne": "Generated · 1 widget · {when}",
  "workspace.assistantBoard.microPartial": "Generated · {shown} of {total} widgets · {when}",
  "workspace.assistantBoard.microLoading": "Generating",
  "workspace.assistantBoard.building": "Building your board…",
  "workspace.assistantBoard.pinAll": "Pin all",
  "workspace.assistantBoard.pinning": "Pinning…",
  "workspace.assistantBoard.pinnedAll": "Pinned",
  "workspace.assistantBoard.saveAsBoard": "Save as board",
  "workspace.assistantBoard.saving": "Saving…",
  "workspace.assistantBoard.saved": "Saved",
  "workspace.assistantBoard.dismiss": "Dismiss",
  "workspace.assistantBoard.refine": "Refine this board",
  "workspace.assistantBoard.pinItem": "Pin to home: {title}",
  "workspace.assistantBoard.pinnedItem": "Pinned to home: {title}",
  "workspace.assistantBoard.blockFooter": "AI · from {app} {dataset}",
  "workspace.assistantBoard.blockFooterBare": "AI · generated",
  "workspace.assistantBoard.emptyItem": "Nothing for {params}",
  "workspace.assistantBoard.empty": "No widget fits this question.",
  "workspace.assistantBoard.noneInstalled": "The widgets for this question are not installed.",
  "workspace.assistantBoard.failed": "The board could not be built.",
  "workspace.assistantBoard.timeout": "Building the board took too long.",
  "workspace.assistantBoard.unavailable": "Generated boards are not available yet.",
  "workspace.assistantBoard.tryAgain": "Try again",
  "workspace.assistantBoard.pinFailed": "The widget could not be pinned.",
  "workspace.assistantBoard.pinDuplicate": "This widget is already on your home.",
  "workspace.assistantBoard.saveFailed": "The board could not be saved.",
  "workspace.assistantBoard.threads": "Recent prompts",
  "workspace.assistantBoard.homeBoard": "Home",
  "workspace.assistantBoard.boards": "Boards",
  "workspace.assistantBoard.shortcutDismiss": "Close the generated board",
  "workspace.assistantBoard.shortcutPin": "Pin the selected widget to home",
  "workspace.assistantBoard.share": "Share",
  "workspace.assistantBoard.sharing": "Sharing…",
  "workspace.assistantBoard.shared": "Link copied",
  "workspace.assistantBoard.linkCopied": "Board link copied",
  "workspace.assistantBoard.linkCopiedHint": "Members of this workspace can open it.",
  "workspace.assistantBoard.period": "Period",
  "workspace.assistantBoard.refresh": "Refresh data",
  "workspace.assistantBoard.renameField": "Board name",
  "workspace.assistantBoard.copyTitle": "{title} (copy)",
  "workspace.assistantBoard.deleteTitle": "Delete “{title}”?",
  "workspace.assistantBoard.deleteMessage": "This permanently removes the board for everyone who can open it. This cannot be undone.",
  "workspace.assistantBoard.renameFailed": "The name could not be saved.",
  "workspace.assistantBoard.duplicateFailed": "The board could not be copied.",
  "workspace.assistantBoard.deleteFailed": "The board could not be deleted.",
  "workspace.assistantDeck.region": "Presentation",
  "workspace.assistantDeck.roleDescription": "slide deck",
  "workspace.assistantDeck.presenterLabel": "Presentation on the full screen",
  "workspace.assistantDeck.micro": "Presentation · {count} slides · {when}",
  "workspace.assistantDeck.microLoading": "Building the presentation",
  "workspace.assistantDeck.counter": "{index} of {count}",
  "workspace.assistantDeck.previous": "Previous",
  "workspace.assistantDeck.next": "Next",
  "workspace.assistantDeck.present": "Present",
  "workspace.assistantDeck.exitPresent": "Exit",
  "workspace.assistantDeck.save": "Save presentation",
  "workspace.assistantDeck.saving": "Saving…",
  "workspace.assistantDeck.saved": "Saved",
  "workspace.assistantDeck.dismiss": "Close the presentation",
  "workspace.assistantDeck.notes": "Speaker notes",
  "workspace.assistantDeck.emptySlide": "This slide has no data in this workspace.",
  "workspace.assistantDeck.failed": "The presentation could not be built.",
  "workspace.assistantDeck.timeout": "Building the presentation took too long.",
  "workspace.assistantDeck.unavailable": "Presentations are not available here yet.",
  "workspace.assistantDeck.empty": "No slide could be built from this workspace's data.",
  "workspace.assistantDeck.saveFailed": "The presentation could not be saved.",
  "workspace.assistantDeck.shortcutDismiss": "Close the presentation",
  "workspace.assistantDeck.shortcutPrevious": "Previous slide",
  "workspace.assistantDeck.shortcutNext": "Next slide",
  "workspace.assistantFly.region": "Fly",
  "workspace.assistantFly.pageCount": "{n} pages",
  "workspace.assistantFly.new": "New",
  "workspace.assistantFly.close": "Close Fly",
  "workspace.assistantFly.shortcutClose": "Close Fly",
  "workspace.assistantFly.composedBy": "Composed by the AI",
  "workspace.assistantFly.composedByAgent": "Composed by {name}",
  "workspace.assistantFly.justNow": "just now",
  "workspace.assistantFly.minutesAgo": "{n} min ago",
  "workspace.assistantFly.statusCompose": "Composing the page…",
  "workspace.assistantFly.statusData": "Reading the data…",
  "workspace.assistantFly.statusWrite": "Writing…",
  "workspace.assistantFly.failed": "This page could not be made.",
  "workspace.assistantFly.failedTimeout": "That took too long.",
  "workspace.assistantFly.failedEmpty": "No app in this workspace can show this yet.",
  "workspace.assistantFly.failedCredits": "This workspace does not have enough AI credits for this page.",
  "workspace.assistantFly.stopped": "This page was stopped.",
  "workspace.assistantFly.failedModel": "The AI could not draft this page. Try again: a second try usually works.",
  "workspace.assistantFly.failedBusy": "The AI is busy right now. Try again in a minute.",
  "workspace.assistantFly.failedAccess": "You do not have access to some of the data this page needs.",
  "workspace.assistantFly.unavailable": "Fly is not available in this workspace yet.",
  "workspace.assistantFly.retry": "Try again",
  "workspace.assistantFly.again": "Ask again",
  "workspace.assistantFly.share": "Copy link",
  "workspace.assistantFly.save": "Save as board",
  "workspace.assistantFly.saved": "Saved",
  "workspace.assistantFly.savedHint": "The page is with your saved boards.",
  "workspace.assistantFly.openBoard": "Open board",
  "workspace.assistantFly.linkCopied": "Link copied",
  "workspace.assistantFly.linkCopiedHint": "It asks the same question for whoever opens it.",
  "workspace.assistantFly.next": "Ask next",
  "workspace.assistantFly.showPage": "Show page",
  "workspace.assistantFly.fold": "Fold page",
  "workspace.assistantFly.earlier": "Earlier pages ({n})",
  "workspace.assistantFly.fewer": "Show fewer",
  "workspace.assistantFly.sectionCount": "{n} sections",
  "workspace.assistantFly.sectionCountOne": "1 section",
  "workspace.assistantFly.took": "{s} s",
  "workspace.assistantFly.doIt": "Do it",
  "workspace.assistantFly.actionLabel": "The change this request asks for",
  "workspace.assistantFly.askedBy": "asked by {name}",
  "workspace.assistantFly.callHide": "Hide for me",
  "workspace.assistantFly.callLabel": "The call's pages",
  "workspace.assistantFly.callStop": "Stop showing for everyone",
  "workspace.assistantFly.callTitle": "{room} · pages",
  "workspace.assistantFly.callTitleBare": "Call pages",
  "workspace.assistantFly.ui.reading": "Reading {what}…",
  "workspace.assistantFly.ui.empty": "Nothing to show here.",
  "workspace.assistantFly.ui.timeout": "This took too long to read.",
  "workspace.assistantFly.ui.aborted": "This read stopped.",
  "workspace.assistantFly.ui.roleRequired": "Your role cannot see this.",
  "workspace.assistantFly.ui.toolUnavailable": "This cannot be read here.",
  "workspace.assistantFly.ui.notFound": "Nothing matches what this section looked for.",
  "workspace.assistantFly.ui.sourceFailed": "The read this section needed did not come back.",
  "workspace.assistantFly.ui.failed": "This could not be read.",
  "workspace.assistantFly.ui.invalid": "This result cannot be shown here.",
  "workspace.homeView.label": "Home view",
  "workspace.homeView.main": "Main",
  "workspace.homeView.chat": "Chat",
  "workspace.homeView.present": "Present",
  "workspace.homeView.build": "Build",
  "workspace.homeTab.chat.titleLead": "Ask {workspace}",
  "workspace.homeTab.chat.titleRest": "anything, with live data from its apps.",
  "workspace.homeTab.present.titleLead": "Present {workspace}",
  "workspace.homeTab.present.titleRest": "as a live deck.",
  "workspace.homeTab.present.lead": "Each slide holds live cards from its apps. Show it full screen, or save it beside your boards.",
  "workspace.homeTab.present.week": "Present this week's highlights",
  "workspace.homeTab.present.attention": "Present what needs attention",
  "workspace.homeTab.present.app": "Present {app}: where we stand",
  "workspace.homeTab.present.kept": "Your decks",
  "workspace.homeTab.present.unsaved": "Not saved",
  "workspace.flyStart.titleLead": "Ask {workspace}",
  "workspace.flyStart.titleRest": "for the page you need.",
  "workspace.flyStart.lead": "Fly composes each page from this workspace's apps — live data, your own access.",
  "workspace.flyStart.tilesLabel": "Start from",
  "workspace.flyStart.more": "+{n} more",
  "workspace.flyStart.ask.overdue": "{app}: what is overdue?",
  "workspace.flyStart.ask.dueToday": "{app}: what is due today?",
  "workspace.flyStart.ask.upcoming": "{app}: what is coming up?",
  "workspace.flyStart.ask.waiting": "{app}: what is waiting on me?",
  "workspace.flyStart.ask.risk": "{app}: what needs attention?",
  "workspace.firstRun.title": "Get started",
  "workspace.firstRun.titleDone": "You're all set",
  "workspace.firstRun.lead": "Four ways to start working in {workspace}.",
  "workspace.firstRun.leadFly": "Fly, the Symbols setup assistant, set up {workspace} with you. These steps come next.",
  "workspace.firstRun.leadDone": "{workspace} is up and running.",
  "workspace.firstRun.hide": "Hide these steps",
  "workspace.firstRun.progress": "{n} of {total}",
  "workspace.firstRun.stepDone": "Done",
  "workspace.firstRun.invite.title": "Invite your team",
  "workspace.firstRun.invite.hint": "Work in {workspace} together.",
  "workspace.firstRun.invite.action": "Invite",
  "workspace.firstRun.records.title": "Add your first records",
  "workspace.firstRun.records.hint": "Add what you work on to an app.",
  "workspace.firstRun.records.hintReady": "Your apps are ready — fill them with your work.",
  "workspace.firstRun.records.action": "Open {app}",
  "workspace.firstRun.records.actionApps": "Open apps",
  "workspace.firstRun.publish.title": "Publish your website",
  "workspace.firstRun.publish.hint": "Make a website and put it online.",
  "workspace.firstRun.publish.hintReady": "Your website project is ready — publish it.",
  "workspace.firstRun.publish.action": "Open website",
  "workspace.firstRun.publish.actionList": "See websites",
  "workspace.firstRun.ask.title": "Ask your workspace",
  "workspace.firstRun.ask.hint": "Ask what is due, what is new and who is on the team.",
  "workspace.firstRun.ask.action": "Ask",
  "workspace.firstRun.presetLine": "Set up for your work — start from a preset",
  "workspace.setup.title": "Setting up {workspace}…",
  "workspace.setup.titleNoName": "Getting your workspace ready…",
  "workspace.setup.titleDone": "{workspace} is ready",
  "workspace.setup.titleDoneNoName": "Your workspace is ready",
  "workspace.setup.titleFailed": "The setup of {workspace} stopped",
  "workspace.setup.titleFailedNoName": "The setup stopped",
  "workspace.setup.stepName": "Workspace name",
  "workspace.setup.stepLanguage": "Workspace language",
  "workspace.setup.stepTheme": "Theme",
  "workspace.setup.stepPreset": "Channels and folders",
  "workspace.setup.stepWebsite": "Website",
  "workspace.setup.lineWorking": "Working…",
  "workspace.setup.lineReady": "Ready",
  "workspace.setup.lineFailed": "Could not finish",
  "workspace.setup.needsApps": "Needs other apps first",
  "workspace.setup.refused": "Not allowed in this workspace",
  "workspace.setup.siteCap": "Free plan limit reached",
  "workspace.setup.noApps": "No app could install",
  "workspace.setup.failedStart": "The setup could not start.",
  "workspace.setup.threadFailed": "The first thread could not be made.",
  "workspace.setup.creditsFree": "Your first build is free.",
  "workspace.setup.credits": "{count} credits left",
  "workspace.setup.creditsOne": "{count} credit left",
  "workspace.setup.back": "Back to {site}",
  "workspace.setup.buildAfter": "Your first build starts when the setup is done.",
  "workspace.setup.buildStarting": "Starting your first build…",
  "workspace.setup.buildAsk": "Your idea is ready to build.",
  "workspace.setup.buildAction": "Build",
  "workspace.setup.buildCredits": "This workspace has no credits. Get credits to start the build.",
  "workspace.setup.buildCreditsMember": "This workspace has no credits. Ask an admin to add credits.",
  "workspace.setup.claim": "Get credits",
  "workspace.setup.buildFromPlan": "Build the first app for my company, {company}: {tagline}",
  "workspace.setup.buildFromName": "Build the first app for my company, {company}.",
  "workspace.setup.buildPlain": "Build the first app for my workspace.",
  "workspace.setup.planTitle": "Your plan",
  "workspace.setup.planTeam": "Team of {count}",
  "workspace.setup.planTeamOne": "Just you",
  "workspace.setup.planApps": "Apps",
  "workspace.setup.planSite": "Website: {site}",
  "workspace.setup.planIdea": "Your idea",
  "workspace.assistantThread.region": "Assistant thread",
  "workspace.assistantThread.openInSidebar": "Open in sidebar",
  "workspace.assistantThread.close": "Back to home",
  "workspace.assistantThread.closeToPage": "Back to the page",
  "workspace.assistantThread.emptyHint": "Ask anything below — the answer shows here.",
  "workspace.assistantThread.modeAssistant": "Assistant",
  "workspace.assistantThread.modeDashboard": "Dashboard",
  "workspace.assistantThread.modeApps": "Apps",
  "workspace.assistantThread.modeTools": "Tools",
  "workspace.assistantThread.modePresentation": "Presentation",
  "workspace.assistantThread.micro": "{mode} · {count} questions",
  "workspace.assistantThread.microOne": "{mode} · 1 question",
  "workspace.assistantThread.shortcutClose": "Close the assistant thread",
  "workspace.assistantRecords.periodToday": "Today",
  "workspace.assistantRecords.periodThisWeek": "This week",
  "workspace.assistantRecords.periodThisMonth": "This month",
  "workspace.assistantRecords.periodThisQuarter": "This quarter",
  "workspace.assistantRecords.periodLastQuarter": "Last quarter",
  "workspace.assistantRecords.periodThisYear": "This year",
  "workspace.assistantRecords.total": "{count} records",
  "workspace.assistantRecords.totalOne": "1 record",
  "workspace.assistantRecords.shown": "{n} of {total} shown",
  "workspace.assistantRecords.empty": "No records: {title}",
  "workspace.assistantRecords.unavailable": "Record answers are not available yet.",
  "workspace.assistantRecords.denied": "You cannot read these records.",
  "workspace.assistantRecords.failed": "The records could not be read.",
  "workspace.assistantRecords.openRow": "Open {title}",
  "workspace.assistantRecords.other": "Other",
  "workspace.assistantRecords.yes": "Yes",
  "workspace.assistantRecords.no": "No",
  "workspace.assistantRecords.deltaVsPrevious": "{delta} vs the previous period",
  "workspace.assistantRecords.sortedPerCurrency": "Sorted within each currency",
  "workspace.assistantRecords.emptyWithoutFilter": "{count} match without the {field} filter",
  "workspace.assistantRecords.emptyOutsidePeriod": "{count} match outside this period",
  "workspace.assistantRecords.snapped": "Read “{from}” as “{to}”",
  "workspace.assistantRecords.drillOpen": "Show the {value} records",
  "workspace.assistantRecords.drillFilter": "{field}: {value} · from {source}",
  "workspace.assistantRecords.drillClose": "Close {title}",
  "workspace.assistantBlock.openInSplit": "Open in split",
  "workspace.assistantBlock.saveAsApp": "Save as app",
  "workspace.assistantBlock.refine": "Refine",
  "workspace.assistantBlock.refinePrefix": "Refine “{title}”: ",
  "workspace.assistantBlock.sourceView": "Answer view",
  "workspace.assistantBlock.sourceRecords": "From {app} · {collection}",
  "workspace.assistantBlock.sourceBoard": "Board · {count} widgets",
  "workspace.assistantBlock.sourceWidget": "From {app} · widget",
  "workspace.assistantBlock.widgetGone": "This widget is not installed in this workspace.",
  "workspace.assistantBlock.widgetFailed": "This widget's app did not load in this workspace.",
  "workspace.assistantBlock.viewDenied": "You do not have access to this view.",
  "workspace.assistantBlock.viewFailed": "This view could not load here.",
  "workspace.assistantBlock.formReview": "Review and save",
  "workspace.assistantBlock.formReopen": "Open the form again",
  "workspace.assistantBlock.formHint": "Nothing changes until you save it in the form.",
  "workspace.assistantBlock.formSaved": "Saved.",
  "workspace.assistantBlock.formDenied": "You cannot make this change in this workspace.",
  "workspace.assistantBlock.formGone": "This form is not available in this workspace.",
  "workspace.assistantBlock.sourceForm": "From {app} · form",
  "workspace.assistantBlock.sourceAppView": "From {app}",
  "workspace.assistantBlock.sourcesTitle": "Sources",
  "workspace.assistantBlock.sourcesQuery": "Web results: {query}",
  "workspace.assistantBlock.sourcesPage": "From {domain}",
  "workspace.assistantBlock.sourcesFoot": "From the web · {count} sources",
  "workspace.assistantBlock.sourcesFootOne": "From the web · 1 source",
  "workspace.assistantBlock.viewGone": "This view is no longer on this page. Ask again to draw it.",
  "workspace.assistantPopover.close": "Dismiss the answer notice",
  "workspace.history.title": "Workspace History",
  "workspace.history.rail.aria": "History filters",
  "workspace.history.rail.people": "People",
  "workspace.history.rail.everyone": "Everyone",
  "workspace.history.rail.activity": "Activity",
  "workspace.history.rail.allTypes": "All activity",
  "workspace.history.stage.aria": "Activity timeline — the arrow keys move between days",
  "workspace.history.step.newer": "Newer days",
  "workspace.history.step.older": "Older days",
  "workspace.history.count.events": "{count} events",
  "workspace.history.count.eventsOne": "1 event",
  "workspace.history.count.people": "{count} people",
  "workspace.history.count.peopleOne": "1 person",
  "workspace.history.count.days": "{count} days",
  "workspace.history.count.daysOne": "1 day",
  "workspace.history.group.stats": "{count} events · {score} pts",
  "workspace.history.group.statsOne": "1 event · {score} pts",
  "workspace.history.group.more": "Show all {count}",
  "workspace.history.group.less": "Show less",
  "workspace.history.type.standup": "Standup",
  "workspace.history.type.ticketUpdate": "Task update",
  "workspace.history.type.noteEdit": "Note edit",
  "workspace.history.type.kbEdit": "KB edit",
  "workspace.history.type.meetCall": "Meet call",
  "workspace.history.state.loading": "Loading the activity log…",
  "workspace.history.state.error": "The activity log could not be read.",
  "workspace.history.state.empty": "No activity yet. Events appear here as people work in this workspace.",
  "workspace.history.state.emptyFiltered": "Nothing matches this filter.",
  "workspace.broadcast.empty": "Share an announcement, poll, or update with the whole workspace.",
  "workspace.broadcast.readTime": "{count} min read",
  "workspace.broadcastStudio.audience.external": "External",
  "workspace.broadcastStudio.audience.workspace": "Workspace",
  "workspace.broadcastStudio.card.deleteAria": "Delete update",
  "workspace.broadcastStudio.card.edit": "Edit",
  "workspace.broadcastStudio.card.moreAria": "More update actions",
  "workspace.broadcastStudio.card.openExternal": "Open external release →",
  "workspace.broadcastStudio.composer.audienceAria": "Release audience",
  "workspace.broadcastStudio.composer.caption": "Choose the audience first. The publishing queue stays focused from there.",
  "workspace.broadcastStudio.composer.closeAria": "Close release editor",
  "workspace.broadcastStudio.composer.externalHint": "External releases can link to a public destination.",
  "workspace.broadcastStudio.composer.publish": "Publish update",
  "workspace.broadcastStudio.composer.publishing": "Publishing…",
  "workspace.broadcastStudio.publish.titleWorkspace": "Publish “{title}” to the workspace?",
  "workspace.broadcastStudio.publish.titleExternal": "Publish “{title}” as an external release?",
  "workspace.broadcastStudio.composer.saveChanges": "Save changes",
  "workspace.broadcastStudio.composer.titleEdit": "Edit release",
  "workspace.broadcastStudio.composer.titleNew": "Write a release",
  "workspace.broadcastStudio.composer.workspaceHint": "Workspace updates are visible to your team.",
  "workspace.broadcastStudio.delete.confirm": "Delete update",
  "workspace.broadcastStudio.delete.message": "This removes the announcement for everyone in the workspace.",
  "workspace.broadcastStudio.delete.title": "Delete this update?",
  "workspace.broadcastStudio.field.destination": "PUBLIC DESTINATION",
  "workspace.broadcastStudio.field.headline": "HEADLINE",
  "workspace.broadcastStudio.field.headlinePlaceholder": "What should people know?",
  "workspace.broadcastStudio.field.summary": "SUMMARY",
  "workspace.broadcastStudio.field.summaryPlaceholder": "One clear sentence for the feed…",
  "workspace.broadcastStudio.field.topic": "TOPIC",
  "workspace.broadcastStudio.field.topicPlaceholder": "News",
  "workspace.broadcastStudio.field.update": "UPDATE",
  "workspace.broadcastStudio.field.updatePlaceholder": "Write the update. Separate paragraphs with a blank line…",
  "workspace.broadcastStudio.preview.audienceExternal": "External release",
  "workspace.broadcastStudio.preview.audienceWorkspace": "Workspace update",
  "workspace.broadcastStudio.preview.tagDefault": "News",
  "workspace.broadcastStudio.preview.untitled": "Untitled update",
  "workspace.broadcastStudio.tag.all": "All news",
  "workspace.broadcastStudio.authorFallback": "Workspace",
  "workspace.broadcastStudio.error.badUrl": "Use a valid external URL, or leave it blank.",
  "workspace.broadcastStudio.error.deleteFailed": "Update could not be deleted.",
  "workspace.broadcastStudio.error.noBody": "Write the update before publishing.",
  "workspace.broadcastStudio.error.noId": "The saved announcement did not include an id.",
  "workspace.broadcastStudio.error.noTitle": "Add a clear headline before publishing.",
  "workspace.broadcastStudio.error.publishFailed": "The update could not be published. Try again.",
  "workspace.broadcastStudio.error.reactionFailed": "Reaction could not be saved.",
  "workspace.broadcastStudio.reactionYou": "You",
  "workspace.callInvite.aria": "Call invitation",
  "workspace.callInvite.dismiss": "Dismiss",
  "workspace.callInvite.dismissAria": "Dismiss call invitation",
  "workspace.callInvite.eyebrow": "Call invitation",
  "workspace.callInvite.join": "Join call",
  "workspace.callInvite.startingNow": "Starting now",
  "workspace.callInvite.startsIn": "Starts in {count} min",
  "workspace.callInvite.untitled": "Meeting",
  "workspace.callPanel.action.accept": "Accept",
  "workspace.callPanel.action.decline": "Decline",
  "workspace.callPanel.action.dismiss": "Dismiss",
  "workspace.callPanel.action.hangUp": "Hang up",
  "workspace.callPanel.action.hold": "Hold",
  "workspace.callPanel.action.keypad": "Keypad",
  "workspace.callPanel.action.mute": "Mute",
  "workspace.callPanel.aria": "Call",
  "workspace.callPanel.calling": "Calling",
  "workspace.callPanel.confirm.decline": "Decline this call?",
  "workspace.callPanel.confirm.end": "End this call?",
  "workspace.callPanel.confirm.keep": "Keep",
  "workspace.callPanel.confirm.yes": "End call",
  "workspace.callPanel.duration": "Duration {duration}",
  "workspace.callPanel.ended.busy": "Line busy",
  "workspace.callPanel.ended.canceled": "Call canceled",
  "workspace.callPanel.ended.completed": "Call ended",
  "workspace.callPanel.ended.failed": "Call failed",
  "workspace.callPanel.ended.missed": "Missed call",
  "workspace.callPanel.ended.noAnswer": "No answer",
  "workspace.callPanel.error.accept": "The call could not be answered",
  "workspace.callPanel.error.hangUp": "The call could not be ended. Try again",
  "workspace.callPanel.error.hold": "The call could not be put on hold",
  "workspace.callPanel.error.microphone": "Allow the microphone to make calls from the workspace",
  "workspace.callPanel.error.start": "The call did not start",
  "workspace.callPanel.error.callError": "The call had a problem. Try again",
  "workspace.callPanel.error.device": "Calling from this browser is not available now",
  "workspace.callPanel.error.notConnected": "The call could not connect",
  "workspace.callPanel.error.role": "Only a workspace owner, admin or member can answer and make calls",
  "workspace.callPanel.incoming": "Incoming call",
  "workspace.callPanel.keypad": "Dial pad",
  "workspace.callPanel.onCall": "On call",
  "workspace.callPanel.onHold": "On hold",
  "workspace.callPanel.ringing": "Ringing",
  "workspace.callPanel.unknownCaller": "Unknown number",
  "workspace.caption.activeNow": "active now",
  "workspace.caption.aiAgents": "AI agents",
  "workspace.caption.delegated": "delegated",
  "workspace.caption.next7Days": "next 7 days",
  "workspace.caption.notes": "notes",
  "workspace.caption.openTasks": "open tasks",
  "workspace.caption.openTickets": "open tickets",
  "workspace.caption.teamMembers": "team members",
  "workspace.caption.timeZones": "time zones",
  "workspace.caption.today": "today",
  "workspace.caption.unread": "unread",
  "workspace.caption.urgentOrHigh": "urgent or high",
  "workspace.catalog.activity": "Your activity",
  "workspace.catalog.agents": "Team & agents",
  "workspace.catalog.analytics": "Active right now",
  "workspace.catalog.appAgents": "Agents",
  "workspace.catalog.appAnalytics": "Analytics",
  "workspace.catalog.appBroadcast": "Broadcast",
  "workspace.catalog.appCalendar": "Calendar",
  "workspace.catalog.appChat": "Chat",
  "workspace.catalog.appDocuments": "Notes",
  "workspace.catalog.appHealth": "System Health",
  "workspace.catalog.appInfra": "Infrastructure",
  "workspace.catalog.appMeet": "Meet",
  "workspace.catalog.appPeople": "People",
  "workspace.catalog.appReminders": "Reminders",
  "workspace.catalog.appStudio": "Apps",
  "workspace.catalog.appTeam": "Team",
  "workspace.catalog.appTickets": "Tasks",
  "workspace.catalog.assets": "Notes",
  "workspace.catalog.broadcast": "Broadcast",
  "workspace.catalog.events": "Coming up",
  "workspace.catalog.given": "Given tasks",
  "workspace.catalog.greeting": "Greeting",
  "workspace.catalog.mailInbox": "Inbox",
  "workspace.catalog.nextUp": "Next up",
  "workspace.catalog.prioritymix": "Priority mix",
  "workspace.catalog.projects": "Projects",
  "workspace.catalog.received": "Received tasks",
  "workspace.catalog.teampulse": "Team pulse",
  "workspace.catalog.teamtime": "Team timezones",
  "workspace.catalog.workload": "Workload",
  "workspace.catalog.youragents": "Your agents",
  "workspace.catalogCard.active": "Active",
  "workspace.catalogCard.details": "Details",
  "workspace.catalogCard.install": "Install",
  "workspace.catalogCard.installing": "Installing…",
  "workspace.company.page.eyebrow": "About",
  "workspace.company.page.heading": "Company",
  "workspace.company.page.title": "Company",
  "workspace.company.res.figma": "Figma UI Library",
  "workspace.company.res.github": "GitHub Organization",
  "workspace.company.res.landing": "Landing Page",
  "workspace.company.res.npm": "npm Packages",
  "workspace.company.res.pitchDeck": "Pitch Deck",
  "workspace.company.res.platformDocs": "Platform Docs",
  "workspace.company.res.sdkDocs": "SDK Docs",
  "workspace.company.section.address": "Address",
  "workspace.company.section.overview": "Overview",
  "workspace.company.section.registration": "Registration",
  "workspace.company.section.resources": "Resources",
  "workspace.createAgent.access": "Access",
  "workspace.createAgent.cancel": "Cancel",
  "workspace.createAgent.failed": "Failed to create agent",
  "workspace.createAgent.name": "Name",
  "workspace.createAgent.namePlaceholder": "e.g. Atlas",
  "workspace.createAgent.role": "Role (optional)",
  "workspace.createAgent.rolePlaceholder": "e.g. Research assistant",
  "workspace.createAgent.runsIn": "Runs in",
  "workspace.createAgent.runsInProjectHint": "The agent only sees and acts inside this project.",
  "workspace.createAgent.runsInWorkspaceHint": "The agent operates across the whole workspace.",
  "workspace.createAgent.submit": "Create agent",
  "workspace.createAgent.submitting": "Creating…",
  "workspace.createAgent.subtitle": "Name your agent, choose what it may do and where it runs. It joins your Team & agents canvas, assigned to you.",
  "workspace.createAgent.title": "Create agent",
  "workspace.createAgent.unavailable": "Agent creation is rolling out — the create API isn’t available on this build yet.",
  "workspace.createMember.cancel": "Cancel",
  "workspace.createMember.email": "Email",
  "workspace.createMember.emailPlaceholder": "e.g. teammate@company.com",
  "workspace.createMember.inviteFailed": "Invite failed",
  "workspace.createMember.noOrg": "No active organization to invite into.",
  "workspace.createMember.role": "Role",
  "workspace.createMember.roleAdmin": "Admin",
  "workspace.createMember.roleMember": "Member",
  "workspace.createMember.sent": "Invite sent",
  "workspace.createMember.sentBody": "Invited {email} to the team.",
  "workspace.createMember.submit": "Send invite",
  "workspace.createMember.submitting": "Inviting…",
  "workspace.createMember.subtitle": "Send an invite by email. They join your organization and show up on the Team & agents canvas.",
  "workspace.createMember.title": "Invite team member",
  "workspace.createOrg.cancel": "Cancel",
  "workspace.createOrg.nameLabel": "Workspace name",
  "workspace.createOrg.namePlaceholder": "Acme",
  "workspace.createOrg.slugAdjusted": "Slug auto-adjusted to \"{suggestion}\" — available and ready.",
  "workspace.createOrg.slugAria": "Workspace URL slug",
  "workspace.createOrg.slugTaken": "This slug is taken. Edit it above.",
  "workspace.createOrg.slugTakenEdit": "\"{slug}\" is taken. Edit the slug above to pick a different one.",
  "workspace.createOrg.slugTakenTry": "\"{slug}\" was just taken — try \"{suggestion}\" instead.",
  "workspace.createOrg.submit": "Create workspace",
  "workspace.createOrg.submitting": "Creating…",
  "workspace.createOrg.subtitle": "A workspace is your team’s shared space — invite teammates and add projects right after.",
  "workspace.createOrg.title": "Create team's workspace",
  "workspace.createOrg.urlLabel": "Workspace URL",
  "workspace.createOrg.usePersonal": "Use personal workspace",
  "workspace.createOrg.errorFailed": "Failed to create workspace",
  "workspace.createOrg.errorRequired": "Name and slug are required",
  "workspace.createOrg.errorSlugTaken": "Slug \"{slug}\" was just taken.",
  "workspace.createOrg.slugStatusAdjusted": "auto-adjusted",
  "workspace.createOrg.slugStatusAvailable": "available",
  "workspace.createOrg.slugStatusChecking": "checking…",
  "workspace.createOrg.slugStatusTaken": "taken",
  "workspace.createOrg.useSlug": "Use \"{slug}\"",
  "workspace.creditBanner.addCredits": "Add credits",
  "workspace.creditBanner.askAdmin": "Ask an admin",
  "workspace.creditBanner.askAdminTitle": "Tell your workspace admins you need credits",
  "workspace.creditBanner.asked": "Admins told",
  "workspace.creditBanner.critical": "Credits almost gone — {count} left",
  "workspace.creditBanner.dismissAria": "Dismiss credit warning",
  "workspace.creditBanner.dismissTitle": "Dismiss until it escalates",
  "workspace.creditBanner.exhausted": "Out of credits — metered actions paused",
  "workspace.creditBanner.low": "Credits running low — {count} left",
  "workspace.creditBanner.short": "Your last AI request needs about {needed} credits — this workspace has {available}",
  "workspace.creditBanner.topUp": "Top up",
  "workspace.creditBanner.topUpTitle": "Open the credit usage page",
  "workspace.creditBlocker.aria": "Workspace is out of credits",
  "workspace.creditBlocker.askAdmin": "Ask a workspace admin to top up — they will see it under Credits.",
  "workspace.creditBlocker.body": "AI, builds and metered actions are paused — everything else stays readable. The monthly grant resets on your billing date, or top up now and keep going.",
  "workspace.creditBlocker.dismissAria": "Dismiss",
  "workspace.creditBlocker.dismissTitle": "Dismiss (Esc)",
  "workspace.creditBlocker.eyebrow": "Workspace credits",
  "workspace.creditBlocker.grantNote": "monthly grant · {count} credits",
  "workspace.creditBlocker.grantNoteOne": "monthly grant · 1 credit",
  "workspace.creditBlocker.headline": "out of credits",
  "workspace.creditBlocker.lead": "{name} is ",
  "workspace.creditBlocker.thisWorkspace": "This workspace",
  "workspace.creditBlocker.topUp": "Top up credits",
  "workspace.credits.allocation.message": "This workspace used its share of the org credit pool — raise its allocation under Usage & billing.",
  "workspace.credits.allocation.title": "Workspace allocation exhausted",
  "workspace.credits.ask.body": "{name} asked for AI credits in {workspace}: the last AI request needs about {needed} and the workspace has {available}.",
  "workspace.credits.ask.failedMessage": "Ask a workspace admin to add credits.",
  "workspace.credits.ask.failedTitle": "Could not send the request",
  "workspace.credits.ask.sentMessage": "Your workspace admins will see it in their notifications.",
  "workspace.credits.ask.sentTitle": "Request sent",
  "workspace.credits.ask.title": "AI credits requested",
  "workspace.credits.ask.whoMessage": "Ask {names} to add credits.",
  "workspace.credits.blocked.message": "AI calls are paused until you top up or upgrade under Usage & billing.",
  "workspace.credits.blocked.title": "Workspace is out of credits",
  "workspace.credits.chat.addLink": "Add credits",
  "workspace.credits.chat.allocation": "This workspace used its share of the organization's AI credits.",
  "workspace.credits.chat.balanceAdmin": "{link} to keep going.",
  "workspace.credits.chat.balanceMember": "Ask a workspace admin to add credits.",
  "workspace.credits.chat.limitAdmin": "{link}, or wait for it to reset next billing cycle.",
  "workspace.credits.chat.limitLink": "Raise the limit",
  "workspace.credits.chat.limitMember": "Ask a workspace admin to raise the limit.",
  "workspace.credits.chat.notEnough": "This workspace does not have enough AI credits for that.",
  "workspace.credits.chat.short": "This needs about {needed} AI credits and the workspace has {available}.",
  "workspace.credits.chat.spendCap": "This workspace reached its AI spending limit.",
  "workspace.credits.critical.message": "{workspace} has {count} credits left.",
  "workspace.credits.critical.title": "Credits almost gone",
  "workspace.credits.exhausted.message": "{workspace} has 0 credits left — AI and metered actions are paused until a top-up.",
  "workspace.credits.exhausted.title": "Workspace is out of credits",
  "workspace.credits.low.message": "{workspace} has {count} credits left this month.",
  "workspace.credits.low.title": "Credits running low",
  "workspace.credits.member.message": "Contact your workspace administrator to top up or upgrade.",
  "workspace.credits.member.title": "This workspace is out of AI credits",
  "workspace.credits.spendCap.message": "Raise the cap under Usage & billing, or it resets next billing cycle.",
  "workspace.credits.spendCap.title": "Workspace hit its spend cap",
  "workspace.credits.thisWorkspace": "This workspace",
  "workspace.ctxMenu.broadcast.delete": "Delete update…",
  "workspace.ctxMenu.broadcast.edit": "Edit update…",
  "workspace.ctxMenu.broadcast.open": "Open update",
  "workspace.ctxMenu.reminder.delete": "Delete reminder…",
  "workspace.ctxMenu.reminder.deleteBody": "This reminder will be removed from your list.",
  "workspace.ctxMenu.reminder.deleteConfirm": "Delete this reminder?",
  "workspace.ctxMenu.reminder.deleteCta": "Delete reminder",
  "workspace.ctxMenu.reminder.markDone": "Mark as done",
  "workspace.ctxMenu.reminder.markOpen": "Mark as open",
  "workspace.ctxMenu.reminder.toEvent": "Create calendar event…",
  "workspace.ctxMenu.reminder.toTicket": "Convert to ticket…",
  "workspace.ctxMenu.reminder.toTicketBody": "A ticket will be created and this reminder will be removed.",
  "workspace.ctxMenu.reminder.toTicketConfirm": "Convert this reminder to a ticket?",
  "workspace.ctxMenu.reminder.toTicketCta": "Convert to ticket",
  "workspace.ctxMenu.system.copied": "Status summary copied",
  "workspace.ctxMenu.system.copyFailed": "Could not copy status summary",
  "workspace.ctxMenu.system.copyFailedBody": "Select the status details manually and try again.",
  "workspace.ctxMenu.system.copySummary": "Copy status summary",
  "workspace.ctxMenu.system.refresh": "Refresh checks",
  "workspace.ctxMenu.system.summary": "System Health: {details}",
  "workspace.ctxMenu.system.summaryEmpty": "no status data yet",
  "workspace.customize.close": "Close customize drawer",
  "workspace.customize.hidden": "Hidden widgets",
  "workspace.customize.hintNoneHidden": "Click × on any card to hide it. Hidden widgets reappear here — click to bring them back.",
  "workspace.customize.hintSomeHidden": "Click any widget below to restore it.",
  "workspace.customize.reset": "Reset layout to defaults",
  "workspace.customize.resetConfirmMessage": "Every widget returns to its default size, position and visibility. Any custom arrangement you made is lost.",
  "workspace.customize.resetConfirmTitle": "Reset layout to defaults?",
  "workspace.customize.resetFailed": "Couldn't reset your layout",
  "workspace.customize.resetFailedMessage": "Your dashboard could not be reset — the change was not saved. Nothing has been changed on the server. Please try again.",
  "workspace.customize.showPanel": "Show customize panel",
  "workspace.customize.slideAway": "Slide customize panel away",
  "workspace.customize.title": "Customize dashboard",
  "workspace.notificationsAnswer.empty": "No notifications.",
  "workspace.notificationsAnswer.failed": "Could not load the notifications.",
  "workspace.notificationsAnswer.group.earlier": "Earlier",
  "workspace.notificationsAnswer.group.unread": "Unread · {count}",
  "workspace.notificationsAnswer.noUnread": "No unread notifications.",
  "workspace.notificationsAnswer.show.all": "All",
  "workspace.notificationsAnswer.show.unread": "Unread",
  "workspace.notificationsAnswer.show.workspace": "This workspace",
  "workspace.notificationsAnswer.title": "Notifications",
  "workspace.notificationsAnswer.untitled": "Notification",
  "workspace.personalize.appStrip": "App strip",
  "workspace.personalize.navbarIcons": "Navbar icons",
  "workspace.personalize.showStrip": "Show the app strip",
  "workspace.personalize.skyLayout": "Sky layout",
  "workspace.personalize.skyLayoutBottom": "Clouds below",
  "workspace.personalize.skyLayoutTop": "Sky and mountains",
  "workspace.personalize.style": "Style",
  "workspace.personalize.styleDock": "Dock",
  "workspace.personalize.styleRail": "Rail",
  "workspace.personalize.showLabels": "Show app names",
  "workspace.personalize.appsHint": "Drag an app to reorder the strip, or use the arrows.",
  "workspace.personalize.moveUp": "Move {app} up",
  "workspace.personalize.moveDown": "Move {app} down",
  "workspace.personalize.theme": "Theme",
  "workspace.personalize.themeAuto": "Auto",
  "workspace.personalize.themeLight": "Light",
  "workspace.personalize.themeDark": "Dark",
  "workspace.personalize.background": "Background",
  "workspace.personalize.skyClouds": "Clouds",
  "workspace.personalize.skyDunes": "Dunes",
  "workspace.personalize.skyHills": "Hills",
  "workspace.personalize.skyLake": "Lake",
  "workspace.personalize.skyWindow": "Window",
  "workspace.personalize.skyMountains": "Mountains",
  "workspace.personalize.skyNone": "None",
  "workspace.personalize.skyFollow": "Use the workspace background",
  "workspace.personalize.summary": "Summary style",
  "workspace.personalize.summaryBrief": "Brief",
  "workspace.personalize.summarySignals": "Signals",
  "workspace.personalize.widgets": "Widgets",
  "workspace.decision.approve": "Approve",
  "workspace.decision.badge": "Decision needed",
  "workspace.decision.cancel": "Cancel",
  "workspace.decision.clarify": "Clarify",
  "workspace.decision.clarifyLabel": "Your clarification:",
  "workspace.decision.clarifyPlaceholder": "Type your clarification…",
  "workspace.decision.confirmReject": "Confirm reject",
  "workspace.decision.options": "Options:",
  "workspace.decision.reject": "Reject",
  "workspace.decision.rejectLabel": "Reason for rejection (optional):",
  "workspace.decision.rejectPlaceholder": "Explain why this was rejected…",
  "workspace.decision.sendClarification": "Send clarification",
  "workspace.demo.cta": "Try Symbols",
  "workspace.demo.lede": "Enter your email to spin up a personal demo workspace — no password, no credit card.",
  "workspace.demo.page.description": "Enter your email to spin up a personal Symbols demo workspace.",
  "workspace.demo.page.title": "Symbols — Try the live demo workspace",
  "workspace.demo.title": "Try Symbols",
  "workspace.demo.error.hasAccount": "You already have an account — log in at my.symbols.app.",
  "workspace.demo.error.invalidEmail": "Please enter a valid email address.",
  "workspace.demo.error.startFailed": "Could not start your demo — please try again.",
  "workspace.demo.linkSent.title": "Check your inbox",
  "workspace.demo.linkSent.body": "We sent a sign-in link to {email}. Open the link to continue.",
  "workspace.demo.linkSent.useAnother": "Use another email",
  "workspace.demoClaim.banner": "Claim this workspace to keep it — your demo changes reset hourly.",
  "workspace.demoClaim.createPassword": "Create a password",
  "workspace.demoClaim.cta": "Claim this workspace",
  "workspace.demoClaim.email": "Email",
  "workspace.demoClaim.emailPlaceholder": "you@company.com",
  "workspace.demoClaim.error.badCredentials": "Email or password is incorrect.",
  "workspace.demoClaim.error.emailRequired": "Email is required.",
  "workspace.demoClaim.error.logInFailed": "Could not log in. Please try again.",
  "workspace.demoClaim.error.logInHandoff": "Logged in, but the handoff failed. Open my.symbols.app to continue.",
  "workspace.demoClaim.error.noDemoWorkspace": "Could not resolve the demo workspace to copy. Please reload and try again.",
  "workspace.demoClaim.error.passwordRequired": "Password is required.",
  "workspace.demoClaim.error.passwordShort": "Password must be at least 8 characters.",
  "workspace.demoClaim.error.signUpFailed": "Could not sign up. Please try again.",
  "workspace.demoClaim.error.signUpHandoff": "Signed up, but the handoff failed. Open my.symbols.app and log in.",
  "workspace.demoClaim.haveAccount": "Already have an account? Log in",
  "workspace.demoClaim.ledeLogIn": "Log in to your existing Symbols account — we copy this demo workspace into it.",
  "workspace.demoClaim.ledeSignUp": "Enter your email and set a password. Your demo data stops resetting and becomes your real account.",
  "workspace.demoClaim.logIn": "Log in & copy workspace",
  "workspace.demoClaim.loggingIn": "Logging in…",
  "workspace.demoClaim.newHere": "New here? Sign up instead",
  "workspace.demoClaim.signUp": "Sign up",
  "workspace.demoClaim.signingUp": "Signing up…",
  "workspace.demoClaim.titleLogIn": "Log in to keep your workspace",
  "workspace.demoClaim.titleSignUp": "Sign up to keep your workspace",
  "workspace.demoClaim.yourPassword": "Your password",
  "workspace.demoClaim.pending.title": "Confirm your new email",
  "workspace.demoClaim.pending.body": "The workspace is yours. We sent a verification link to {email}. The new email stays pending until you click that link.",
  "workspace.demoClaim.pending.notSent": "The workspace is yours, but we could not send the verification link to {email}. The new email stays pending until it is confirmed.",
  "workspace.demoClaim.pending.signInNote": "Until then, you cannot sign in with this email.",
  "workspace.demoClaim.pending.continue": "Go to workspace",
  "workspace.events.empty": "Nothing on the calendar this week.",
  "workspace.extend.caption": "Build your own app or widget — Symbols is the OS underneath.",
  "workspace.extend.title": "Extend Symbols",
  "workspace.features.col.feature": "Feature",
  "workspace.features.epic.calendar": "Calendar",
  "workspace.features.epic.canvas": "Canvas",
  "workspace.features.epic.chat": "Chat",
  "workspace.features.epic.documents": "Documents",
  "workspace.features.epic.files": "Files",
  "workspace.features.epic.infra": "Infra",
  "workspace.features.epic.marketplace": "Marketplace",
  "workspace.features.epic.meet": "Meet",
  "workspace.features.epic.shell": "Home / Shell",
  "workspace.features.epic.tickets": "Tasks",
  "workspace.features.epicSub.calendar": "Scheduling across week / month / team views",
  "workspace.features.epicSub.canvas": "The DOMQL design editor & project surfaces",
  "workspace.features.epicSub.chat": "Team messaging, threads & the agent bridge",
  "workspace.features.epicSub.documents": "Library, notes & the knowledge base",
  "workspace.features.epicSub.files": "Shared pan/zoom desktop & documents",
  "workspace.features.epicSub.infra": "Service graph, status & deploy management",
  "workspace.features.epicSub.marketplace": "Catalog, feed & install flow",
  "workspace.features.epicSub.meet": "Live calls powered by LiveKit",
  "workspace.features.epicSub.shell": "The dashboard, navigation & admin suite",
  "workspace.features.epicSub.tickets": "Issue tracking, planning & the release pipeline",
  "workspace.features.eyebrow": "QA & release tracking",
  "workspace.features.filter.all": "All",
  "workspace.features.menu.clearStatus": "Clear status",
  "workspace.features.menu.createTask": "Create a task",
  "workspace.features.menu.linked": "Linked: {id}",
  "workspace.features.menu.reportBug": "Report a bug",
  "workspace.features.menu.unlink": "Unlink ticket",
  "workspace.features.page.title": "Feature matrix",
  "workspace.features.qa.body": "{feature} ({epic}) reported on the {env} environment from the Feature Matrix for {workspace}.",
  "workspace.features.qa.title": "[QA] {feature} — {env}",
  "workspace.features.reset": "Reset this workspace",
  "workspace.features.stat.fail": "Failing",
  "workspace.features.stat.pass": "Passing",
  "workspace.features.stat.total": "Total",
  "workspace.features.stat.unchecked": "Unchecked",
  "workspace.features.status.fail": "Failure",
  "workspace.features.status.pass": "Working",
  "workspace.features.status.unchecked": "Not checked",
  "workspace.features.subtitle": "End-to-end functionality shipped by {workspace}, scoped to this workspace. Click a dot to cycle status; failing or right-click opens the bug / link-ticket menu.",
  "workspace.features.title": "Feature matrix",
  "workspace.features.thisWorkspace": "this workspace",
  "workspace.header.mail.unread": "Unread mail",
  "workspace.header.primaryNav": "Primary",
  "workspace.home.allApps": "All apps",
  "workspace.home.appStrip": "Apps",
  "workspace.home.drop.added": "Added to Home",
  "workspace.home.drop.addedMessage": "{app} was added to your dashboard.",
  "workspace.home.drop.already": "Already on Home",
  "workspace.home.drop.alreadyMessage": "{app} is already on your dashboard.",
  "workspace.home.drop.thisApp": "This app",
  "workspace.home.error.agents": "Failed to load agents",
  "workspace.home.error.members": "Failed to load members",
  "workspace.home.error.tickets": "Failed to load tickets",
  "workspace.home.error.workspaceActivity": "Failed to load workspace activity",
  "workspace.home.error.workspaceActivityEmpty": "Empty workspace-activity response",
  "workspace.home.loadState.activity": "Couldn’t load workspace activity",
  "workspace.home.loadState.reminders": "Couldn’t load reminders",
  "workspace.home.loadState.remindersDescriptor": "Personal follow-ups",
  "workspace.home.loadState.remindersDueToday": "{count} due today",
  "workspace.home.loadState.remindersEmpty": "Nothing on your list — add one above.",
  "workspace.home.greet.afternoon": "Good afternoon, ",
  "workspace.home.greet.evening": "Good evening, ",
  "workspace.home.greet.morning": "Good morning, ",
  "workspace.home.greet.afternoonNoName": "Good afternoon",
  "workspace.home.greet.eveningNoName": "Good evening",
  "workspace.home.greet.morningNoName": "Good morning",
  "workspace.home.greet.night": "Hello, ",
  "workspace.home.greet.nightNoName": "Hello",
  "workspace.home.prefs.notSavedMessage": "Your last dashboard change did not reach the server, so it will not appear on your other devices. Check your connection and try again.",
  "workspace.home.prefs.notSavedTitle": "Dashboard change not saved",
  "workspace.home.quickAdd.addAria": "Add a task",
  "workspace.home.quickAdd.addPlaceholder": "Add a task…",
  "workspace.home.quickAdd.delegateAria": "Delegate a new task",
  "workspace.home.quickAdd.delegatePlaceholder": "Delegate a task…",
  "workspace.home.quickAdd.noteFailed": "Could not add note",
  "workspace.home.quickAdd.taskFailed": "Could not add task",
  "workspace.home.quickAdd.add": "Add",
  "workspace.home.quickAdd.delegate": "Delegate",
  "workspace.home.tip1": "Empty space → Refresh · Customize",
  "workspace.home.tip2": "A widget → its own actions",
  "workspace.home.tipMouse": "Right-click, or press Shift+F10, for options",
  "workspace.home.tipTouch": "Touch and hold for options",
  "workspace.home.tryAgain": "Please try again.",
  "workspace.hub.choose": "Choose a workspace",
  "workspace.hub.oneMoment": "One moment — taking you to your team.",
  "workspace.hub.opening": "Opening your workspace…",
  "workspace.hub.page.title": "Workspaces",
  "workspace.hub.pickToday": "Pick where you want to work today.",
  "workspace.hub.stalledNoOrgs": "We found no workspace for this account. Try again in a moment.",
  "workspace.hub.stalledTitle": "We could not open your workspace",
  "workspace.hub.stalledWithOrgs": "Pick one below, or try again.",
  "workspace.hub.tryAgain": "Try again",
  "workspace.inbox.markAllRead": "Mark all read",
  "workspace.inbox.page.title": "Inbox",
  "workspace.inbox.tab.all": "All",
  "workspace.inbox.tab.unread": "Unread",
  "workspace.inbox.tab.unreadCount": "Unread · {count}",
  "workspace.inbox.tab.workspace": "Workspace",
  "workspace.inbox.tab.workspaceTitle": "Only notifications from the workspace you’re in",
  "workspace.inbox.title": "Inbox",
  "workspace.inbox.empty.all": "You're all caught up",
  "workspace.inbox.empty.unread": "No unread notifications",
  "workspace.inbox.empty.workspace": "Nothing from this workspace",
  "workspace.linked.call": "Call",
  "workspace.linked.conversation": "Conversation",
  "workspace.linked.dm": "DM",
  "workspace.linked.event": "Event",
  "workspace.linked.group": "Group",
  "workspace.linked.label": "Linked:",
  "workspace.meet.startFailed": "Could not start call",
  "workspace.meet.startFailedBody": "Meet room creation failed. Check your connection or try again.",
  "workspace.meet.calendarCall": "Calendar call",
  "workspace.menu.addColor": "Add color",
  "workspace.menu.changeColor": "Change color",
  "workspace.menu.changeWithAi": "Change with AI…",
  "workspace.menu.customize": "Customize dashboard",
  "workspace.menu.deleteWidget": "Delete “{title}”",
  "workspace.menu.hideWidget": "Hide “{title}”",
  "workspace.menu.language": "Language: {language}",
  "workspace.menu.makePersonal": "Make personal",
  "workspace.menu.openApp": "Open {app}",
  "workspace.menu.shareToWorkspace": "Share to workspace",
  "workspace.menu.thisWidget": "this widget",
  "workspace.my.page.title": "My profile",
  "workspace.nav.announcements": "Announcements",
  "workspace.nav.company": "Company",
  "workspace.nav.main": "Main",
  "workspace.nav.my": "My",
  "workspace.nav.searchPlaceholder": "Search across everything…",
  "workspace.nav.teamMembers": "Team members",
  "workspace.navbar.sidebars.hide": "Hide sidebar",
  "workspace.navbar.sidebars.show": "Show sidebar",
  "workspace.navbar.sidebars.toggle": "Toggle sidebar",
  "workspace.newsRow.toggleFavorite": "Toggle favorite",
  "workspace.notFound.caption": "This page doesn't exist.",
  "workspace.notFound.goHome": "Go home",
  "workspace.notFound.title": "Not found",
  "workspace.notes.add": "Add",
  "workspace.notes.empty": "No documents yet — start with a workspace note or knowledge base article.",
  "workspace.notes.newAria": "New note title",
  "workspace.notes.newPlaceholder": "New note…",
  "workspace.notification.fallbackTitle": "Notification",
  "workspace.onlineMembers.more": "{count} more online",
  "workspace.orgChart.empty": "No team members yet.",
  "workspace.orgChart.loadFailed": "Could not load the org chart.",
  "workspace.orgChart.saveFailed": "Save failed.",
  "workspace.orgChart.noManager": "No manager",
  "workspace.orgChart.save": "Save changes",
  "workspace.orgChart.saved": "Org chart updated",
  "workspace.orgChart.savedBody": "Manager changes saved.",
  "workspace.orgChart.saving": "Saving…",
  "workspace.orgChart.subtitle": "See how the team reports, and set managers for the whole team in one place.",
  "workspace.orgChart.tabChart": "Chart",
  "workspace.orgChart.tabEdit": "Edit managers",
  "workspace.orgChart.title": "Org chart",
  "workspace.page.acceptInvite": "Accept invitation / Symbols",
  "workspace.page.addApp": "Add App",
  "workspace.page.apps": "Workspace apps",
  "workspace.page.admin": "Admin",
  "workspace.page.agents": "Agents",
  "workspace.page.analytics": "Analytics",
  "workspace.page.analyticsBugs": "Bugs · Analytics",
  "workspace.page.analyticsEvents": "Events · Analytics",
  "workspace.page.analyticsMap": "Analytics · Map",
  "workspace.page.analyticsSessions": "Sessions · Analytics",
  "workspace.page.analyticsVisitors": "Visitors · Analytics",
  "workspace.page.authCallback": "Signing in… / Symbols",
  "workspace.page.history": "Workspace History",
  "workspace.page.calendar": "Calendar",
  "workspace.page.canvas": "Canvas / Symbols.app",
  "workspace.page.chat": "Chat",
  "workspace.page.dashboard": "Dashboard / Symbols.app",
  "workspace.page.data": "Data",
  "workspace.page.dataExternal": "External data",
  "workspace.page.demo": "Symbols Demo",
  "workspace.page.editor": "Editor",
  "workspace.page.features": "Features",
  "workspace.page.files": "Files",
  "workspace.page.inbox": "Inbox",
  "workspace.page.infra": "Infra",
  "workspace.page.infraStatus": "Status / Infra",
  "workspace.page.kb": "Knowledge Base",
  "workspace.page.login": "Log in / Symbols",
  "workspace.page.logs": "Logs",
  "workspace.page.logsBugs": "Bugs / Logs",
  "workspace.page.logsEvents": "Events / Logs",
  "workspace.page.logsNetwork": "Network / Logs",
  "workspace.page.logsSession": "Session / Logs",
  "workspace.page.logsSessions": "Sessions / Logs",
  "workspace.page.logsUsers": "Users / Logs",
  "workspace.page.logsVerbose": "Verbose / Logs",
  "workspace.page.mail": "Mail",
  "workspace.page.marketplace": "Marketplace",
  "workspace.page.marketplaceCommunity": "Community feed / Marketplace",
  "workspace.page.marketplacePrompts": "Prompt Gallery / Marketplace",
  "workspace.page.marketplaceRailDemo": "InstallableRail Demo / Marketplace",
  "workspace.page.meet": "Meet",
  "workspace.page.myTasks": "My view / Tasks",
  "workspace.page.notFound": "Not found / Symbols.app",
  "workspace.page.notes": "Notes",
  "workspace.page.preview": "Preview",
  "workspace.page.reminders": "Reminders",
  "workspace.page.resetPassword": "Reset password / Symbols",
  "workspace.page.resolutions": "Resolutions",
  "workspace.page.resolutionsAudit": "Audit / Reports / Resolutions",
  "workspace.page.resolutionsEditRequests": "Edit requests / Resolutions",
  "workspace.page.resolutionsImprovements": "Improvements / Resolutions",
  "workspace.page.resolutionsInbound": "Inbound / Resolutions",
  "workspace.page.resolutionsOutbound": "Outbound / Resolutions",
  "workspace.page.resolutionsRequests": "Customer requests / Resolutions",
  "workspace.page.sharedResource": "Shared / Symbols",
  "workspace.page.signin": "Sign in / Symbols",
  "workspace.page.signup": "Sign up / Symbols",
  "workspace.page.signupConfirmation": "Confirm your email / Symbols",
  "workspace.page.systemHealth": "System Health",
  "workspace.page.teamAndAgents": "Team & agents",
  "workspace.page.ticket": "Task",
  "workspace.page.ticketsBoard": "Board / Tasks",
  "workspace.page.ticketsEpics": "Epics & Stories / Tasks",
  "workspace.page.ticketsFeed": "Feed / Tasks",
  "workspace.page.ticketsGeneral": "General / Tasks",
  "workspace.page.ticketsRelease": "Release / Tasks",
  "workspace.page.ticketsRoadmap": "Roadmap / Tasks",
  "workspace.page.ticketsStandups": "Standups / Tasks",
  "workspace.page.ticketsStatus": "Status / Tasks",
  "workspace.page.waitlistInvite": "Join Symbols / Symbols",
  "workspace.page.workspaceAnalytics": "Workspace Analytics",
  "workspace.pageTitle.admin": "Admin",
  "workspace.pageTitle.audit": "Audit / Reports",
  "workspace.pageTitle.board": "Board",
  "workspace.pageTitle.calendar": "Calendar",
  "workspace.pageTitle.call": "Call",
  "workspace.pageTitle.canvas": "Canvas",
  "workspace.pageTitle.chat": "Chat",
  "workspace.pageTitle.epics": "Epics",
  "workspace.pageTitle.feed": "Feed",
  "workspace.pageTitle.general": "General",
  "workspace.pageTitle.inbound": "Inbound",
  "workspace.pageTitle.meet": "Meet",
  "workspace.pageTitle.myView": "My view",
  "workspace.pageTitle.notes": "Notes",
  "workspace.pageTitle.outbound": "Outbound",
  "workspace.pageTitle.release": "Release",
  "workspace.pageTitle.requests": "Requests",
  "workspace.pageTitle.resolutions": "Resolutions",
  "workspace.pageTitle.roadmap": "Roadmap",
  "workspace.pageTitle.standups": "Standups",
  "workspace.pageTitle.stories": "Stories",
  "workspace.pageTitle.systemHealth": "System Health",
  "workspace.pageTitle.tasks": "Tasks",
  "workspace.pageTitle.transcript": "Transcript",
  "workspace.pageTitle.workspaces": "Workspaces",
  "workspace.pageItem.noUi": "No workspace UI available to open this item.",
  "workspace.pageItem.ticketNotFound": "Ticket {id} not found.",
  "workspace.pageItem.channelNotFound": "Channel {id} not found.",
  "workspace.pageItem.documentNotFound": "Document {id} not found.",
  "workspace.pageItem.noteNotFound": "Note {id} not found.",
  "workspace.pageItem.articleNotFound": "Article {id} not found.",
  "workspace.pageItem.eventNotFound": "Event {id} not found.",
  "workspace.pageItem.roomNotFound": "Room {id} not found.",
  "workspace.pageItem.recordNoCollection": "Record {id} can't open: the request named no collection.",
  "workspace.pageItem.recordNoRoute": "No app in this workspace opens records of {collection}, so record {id} can't open here.",
  "workspace.pageItem.recordNotFound": "Record {id} was not found in {collection}, or you don't have access to it.",
  "workspace.pageItem.unknownType": "Unknown page item type \"{type}\".",
  "workspace.people.category.archived": "Archived",
  "workspace.people.category.external": "External",
  "workspace.people.category.manager": "Manager",
  "workspace.people.category.passive": "Passive",
  "workspace.people.category.unassigned": "Unassigned",
  "workspace.people.emptyFilter": "No members match this filter.",
  "workspace.people.emptyGroup": "No members of \"{group}\" are in this organization's roster.",
  "workspace.people.emptyQuery": "No members found for \"{query}\"",
  "workspace.people.eyebrow": "The team",
  "workspace.people.filter.active": "Active",
  "workspace.people.filter.everyone": "Everyone",
  "workspace.people.filter.inactive": "Inactive",
  "workspace.people.filter.other": "Other",
  "workspace.people.group.noTeam": "No team",
  "workspace.people.navAria": "Team members",
  "workspace.people.orgChart": "Org chart",
  "workspace.people.page.title": "Team members",
  "workspace.people.rail.inactive": "Inactive",
  "workspace.people.rail.members": "Members",
  "workspace.people.rail.teams": "Teams",
  "workspace.people.state.emptyBody": "Invite your team to see them here.",
  "workspace.people.state.emptyTitle": "No team members yet",
  "workspace.people.state.errorBody": "Check your connection, then try again.",
  "workspace.people.state.errorTitle": "Team members couldn’t load",
  "workspace.people.state.loading": "Loading team members…",
  "workspace.people.state.reduced": "You can see only your own profile. Your access does not cover the full member list.",
  "workspace.people.title": "Team members",
  "workspace.person.action.assign": "Assign",
  "workspace.person.action.call": "Call",
  "workspace.person.action.chat": "Chat",
  "workspace.person.action.email": "Email",
  "workspace.person.action.meet": "Meet",
  "workspace.person.action.ping": "Ping",
  "workspace.person.action.profile": "Profile",
  "workspace.person.addDirectory": "Add to directory",
  "workspace.person.addDirectoryFailed": "Could not add to directory",
  "workspace.person.addedDirectory": "Added to directory",
  "workspace.person.callFailed": "Could not start the call",
  "workspace.person.callInviteBody": "Join my call: {url}",
  "workspace.person.callRoomName": "Call with {name}",
  "workspace.person.categoryUnassigned": "Unassigned",
  "workspace.person.chatFailed": "Could not open chat",
  "workspace.person.fallbackName": "Person",
  "workspace.person.inDirectory": "In directory",
  "workspace.person.invitedAs": "Invited as {role}",
  "workspace.person.meetingWith": "Meeting with {name}",
  "workspace.person.member": "Member",
  "workspace.person.online": "Online",
  "workspace.person.open": "Open",
  "workspace.person.orgRole": "Org role: {role}",
  "workspace.person.pending": "Pending",
  "workspace.person.pendingInvites": "Pending invitations",
  "workspace.person.pingFailed": "Ping failed",
  "workspace.person.pingFailedSend": "Could not send ping",
  "workspace.person.pingSent": "Ping sent",
  "workspace.person.pingSentBody": "{name} will be notified.",
  "workspace.person.pingedYou": "{name} pinged you",
  "workspace.person.revoke": "Revoke",
  "workspace.person.revokeConfirm": "Revoke invitation?",
  "workspace.person.revokeConfirmBody": "{email} won't be able to join with this invite link anymore.",
  "workspace.person.revokeCta": "Revoke invite",
  "workspace.person.revokeFailed": "Revoke failed",
  "workspace.person.revoked": "Invitation revoked",
  "workspace.person.revokedBody": "{email} is no longer invited.",
  "workspace.person.role": "Role",
  "workspace.person.roleChange.title": "Give {name} the role “{role}”?",
  "workspace.person.roleChange.message": "Their access in this organization changes at once.",
  "workspace.person.roleChange.confirm": "Change role",
  "workspace.person.roleChange.self": "You cannot change your own role. Ask another owner or admin.",
  "workspace.person.tryAgain": "Please try again.",
  "workspace.person.unknown": "Unknown",
  "workspace.person.pingedYouAnon": "Someone pinged you",
  "workspace.personModal.close": "Close",
  "workspace.personModal.noTeams": "No team memberships.",
  "workspace.personModal.openProfile": "Open profile",
  "workspace.personModal.teams": "Teams ({count})",
  "workspace.priority.high": "High",
  "workspace.priority.low": "Low",
  "workspace.priority.medium": "Medium",
  "workspace.priority.urgent": "Urgent",
  "workspace.projects.addToWorkspace": "Add to this workspace",
  "workspace.projects.new": "New project",
  "workspace.pulse.active": "In progress",
  "workspace.pulse.blocked": "Blocked",
  "workspace.pulse.needsYou": "{count} need you",
  "workspace.pulse.needsYouOne": "1 needs you",
  "workspace.pulse.review": "In review",
  "workspace.pulse.todo": "To do",
  "workspace.reaction.all": "All",
  "workspace.reaction.popular": "Popular",
  "workspace.redirect.openingLogs": "Opening Analytics → Logs…",
  "workspace.redirect.openingNotes": "Opening Notes…",
  "workspace.redirect.openingTasks": "Opening Tasks…",
  "workspace.redirect.page.title": "Redirecting",
  "workspace.reminders.addAria": "Add a reminder",
  "workspace.reminders.addFailed": "Could not add reminder",
  "workspace.reminders.composer.add": "Add",
  "workspace.reminders.composer.nextWeek": "Next week",
  "workspace.reminders.composer.pickDate": "Pick a date & time",
  "workspace.reminders.composer.placeholder": "Add a reminder… (@name to mention)",
  "workspace.reminders.composer.today": "Today",
  "workspace.reminders.composer.tomorrow": "Tomorrow",
  "workspace.reminders.convertFailed": "Could not convert to task",
  "workspace.reminders.convertToEvent": "Convert to event",
  "workspace.reminders.convertToTask": "Convert to task",
  "workspace.reminders.converted": "Converted to task",
  "workspace.reminders.delete": "Delete reminder",
  "workspace.reminders.deleteFailed": "Could not delete reminder",
  "workspace.reminders.due": "Reminder due",
  "workspace.reminders.due.overdue": "Overdue · {count}d",
  "workspace.reminders.due.today": "Today {time}",
  "workspace.reminders.due.tomorrow": "Tomorrow",
  "workspace.reminders.empty.completed": "Nothing completed yet.",
  "workspace.reminders.empty.notEnabled": "Reminders isn't enabled for this workspace",
  "workspace.reminders.empty.private": "No private reminders yet — add one above.",
  "workspace.reminders.empty.shared": "No shared reminders yet — add one above.",
  "workspace.reminders.empty.today": "Nothing due today — enjoy the quiet.",
  "workspace.reminders.empty.upcoming": "Nothing on the horizon yet.",
  "workspace.reminders.filter.all": "All",
  "workspace.reminders.filter.completed": "Completed",
  "workspace.reminders.filter.today": "Today",
  "workspace.reminders.filter.upcoming": "Upcoming",
  "workspace.reminders.group.completed": "Completed",
  "workspace.reminders.group.noDate": "No date",
  "workspace.reminders.group.overdue": "Overdue",
  "workspace.reminders.group.today": "Today",
  "workspace.reminders.group.tomorrow": "Tomorrow",
  "workspace.reminders.group.upcoming": "Upcoming",
  "workspace.reminders.listTitle": "Reminders",
  "workspace.reminders.loadFailed": "Failed to load reminders",
  "workspace.reminders.mentionTitle": "{name} mentioned you in a reminder",
  "workspace.reminders.moreAria": "More reminder actions",
  "workspace.reminders.navAria": "Reminders",
  "workspace.reminders.page.title": "Reminders",
  "workspace.reminders.removeDueAria": "Remove due date",
  "workspace.reminders.scope.private": "Private",
  "workspace.reminders.scope.shared": "Shared",
  "workspace.reminders.scopeAria": "Reminder visibility scope",
  "workspace.reminders.scopeTitle": "Scope",
  "workspace.reminders.sharedChip": "Shared with the workspace",
  "workspace.reminders.toggleAria2": "Toggle reminder done",
  "workspace.reminders.tryAgain": "Please try again.",
  "workspace.reminders.untitled": "Untitled",
  "workspace.reminders.updateFailed": "Could not update reminder",
  "workspace.reminders.visibility.private": "Private",
  "workspace.reminders.visibility.shared": "Shared",
  "workspace.reminders.deleteTitle": "Delete “{name}”?",
  "workspace.reminders.deleteSharedBody": "It is shared, so it goes for everyone who sees it.",
  "workspace.remindersAnswer.empty": "No reminders here.",
  "workspace.requestAccess.closed": "Self-serve requests are not open right now. Ask the team for an invitation to this workspace.",
  "workspace.requestAccess.question": "How do you work with the team?",
  "workspace.requestAccess.reviewNote": "We review every request. If it is a fit you will receive an invitation by email.",
  "workspace.requestAccess.sending": "Sending…",
  "workspace.requestAccess.sent": "Request sent",
  "workspace.requestAccess.sentBody": "The team reviews every request and answers by email.",
  "workspace.requestAccess.signOut": "Sign out",
  "workspace.requestAccess.submit": "Request an invitation",
  "workspace.requestAccess.title": "Request access",
  "workspace.requestAccess.yourName": "Your name",
  "workspace.requestAccess.intro": "{who} is not a member of {workspace} yet. Request an invitation — the team reviews every request.",
  "workspace.requestAccess.introNoName": "{who} is not a member of this workspace yet. Request an invitation — the team reviews every request.",
  "workspace.requestAccess.signedInAs": "Signed in as {email}",
  "workspace.requestAccess.yourAccount": "Your account",
  "workspace.rows.join": "Join",
  "workspace.rows.joinCall": "Join call",
  "workspace.rows.openExternal": "Open external release →",
  "workspace.sandbox.frameTitle": "App",
  "workspace.sandbox.marker": "App content — runs isolated from your account",
  "workspace.sandbox.stopped": "This app stopped. Reload the page to start it again.",
  "workspace.search.action.ask": "Ask the assistant about these results",
  "workspace.search.action.askContext": "⌘K search — {filters}",
  "workspace.search.action.askPrompt": "Tell me about the results filtered by {filters}.",
  "workspace.search.action.clear": "Clear filters",
  "workspace.search.action.openIn": "Open in {app}",
  "workspace.search.action.rows": "{count} found",
  "workspace.search.category.actions": "With these results",
  "workspace.search.category.appStore": "Not installed — from the App Store",
  "workspace.search.category.apps": "Apps",
  "workspace.search.category.channels": "Channels",
  "workspace.search.category.chips": "Filtered by",
  "workspace.search.category.commands": "Commands",
  "workspace.search.category.discover": "Nothing found in this workspace",
  "workspace.search.category.events": "Events",
  "workspace.search.category.files": "Files",
  "workspace.search.category.filters": "Filter by",
  "workspace.search.category.integrations": "Not connected — Integrations",
  "workspace.search.category.kb": "Knowledge Base",
  "workspace.search.category.mail": "Mail",
  "workspace.search.category.messages": "Messages",
  "workspace.search.category.notes": "Notes",
  "workspace.search.category.people": "People",
  "workspace.search.category.tickets": "Tasks",
  "workspace.search.chip.remove": "Remove",
  "workspace.search.folder": "Folder",
  "workspace.search.suggest.appStoreCaption": "Browse apps you can install",
  "workspace.search.suggest.appStoreRow": "Install into this workspace",
  "workspace.search.suggest.integrationRow": "Connect this service",
  "workspace.search.suggest.integrations": "Integrations",
  "workspace.search.suggest.integrationsCaption": "Connect an external service",
  "workspace.search.suggest.marketplace": "Marketplace",
  "workspace.search.suggest.marketplaceCaption": "Templates, components and plugins",
  "workspace.search.untitled": "Untitled",
  "workspace.search.untitledDocument": "Untitled document",
  "workspace.sessionBridge.body": "Session bridge. Hands off the SDK session to other Symbols subdomains.",
  "workspace.sessionBridge.page.title": "Session bridge · Symbols",
  "workspace.signInSession.page.title": "Approve a sign-in · Symbols",
  "workspace.signInSession.title": "Approve a sign-in",
  "workspace.signInSession.lead": "A device asks to sign in to your Symbols account. It gets a session to your account.",
  "workspace.signInSession.started": "Started",
  "workspace.signInSession.from": "From",
  "workspace.signInSession.client": "Client",
  "workspace.signInSession.clientCli": "Symbols CLI",
  "workspace.signInSession.clientUnknown": "Unknown client",
  "workspace.signInSession.warning": "Continue ONLY if you started this sign-in yourself, on your own device. If you did not, press Cancel.",
  "workspace.signInSession.codeLabel": "Enter the code your device shows",
  "workspace.signInSession.codeError.missing": "Enter the code your device shows.",
  "workspace.signInSession.codeError.wrong": "That code does not match. Check the code on your device.",
  "workspace.signInSession.continue": "Continue",
  "workspace.signInSession.cancel": "Cancel",
  "workspace.signInSession.done": "Done. Return to your device.",
  "workspace.signInSession.error.expired": "This sign-in link has expired or was already used. Start the sign-in again on your device.",
  "workspace.signInSession.error.locked": "Too many wrong codes. Start the sign-in again on your device.",
  "workspace.signInSession.error.failed": "Could not approve the sign-in. Try again.",
  "workspace.share.copied.message": "Anyone with this link can open it until it expires or you revoke it.",
  "workspace.share.copied.title": "Public link copied",
  "workspace.share.copyFailed.message": "The link was created. Copy it from the field above.",
  "workspace.share.copyFailed.title": "Could not copy",
  "workspace.share.expiry.d30": "30 days",
  "workspace.share.expiry.d7": "7 days",
  "workspace.share.expiry.d90": "90 days",
  "workspace.share.expiry.never": "Never",
  "workspace.share.modal.copy": "Copy",
  "workspace.share.modal.copyOnce": "Copy it now — this link is shown only once",
  "workspace.share.modal.empty": "No links yet. Nothing is public until you create one.",
  "workspace.share.modal.existing": "Links for this item",
  "workspace.share.modal.expiryLabel": "Link expires",
  "workspace.share.modal.liveNotice": "The link always shows the latest version — edits you make later are published too. It stops working when it expires or when you revoke it.",
  "workspace.share.modal.opt30": "30 days (default)",
  "workspace.share.modal.opt7": "7 days",
  "workspace.share.modal.opt90": "90 days",
  "workspace.share.modal.optNever": "Never — stays open until revoked",
  "workspace.share.modal.revoke": "Revoke",
  "workspace.share.modal.subtitle": "Anyone with the link can open {what} — no account needed.",
  "workspace.share.modal.thisFile": "this file",
  "workspace.share.modal.thisNote": "this note",
  "workspace.share.modal.title": "Share publicly",
  "workspace.share.revoked.message": "The link stops working immediately, for everyone who has it.",
  "workspace.share.revoked.title": "Link revoked",
  "workspace.share.revoke.title": "Revoke the public link to “{name}”?",
  "workspace.share.status.days": "Live · expires in {count} days",
  "workspace.share.status.expired": "Expired",
  "workspace.share.status.never": "Live · never expires",
  "workspace.share.status.revoked": "Revoked",
  "workspace.share.status.today": "Live · expires today",
  "workspace.share.error.createFailed": "Could not create the link",
  "workspace.share.error.loadFailed": "Could not load the existing links",
  "workspace.share.error.revokeFailed": "Could not revoke the link",
  "workspace.share.uses.many": "opened {count} times",
  "workspace.share.uses.never": "never opened",
  "workspace.share.uses.once": "opened once",
  "workspace.shareLink.create": "Create link",
  "workspace.shareLink.creating": "Working…",
  "workspace.shareLink.expiryLabel": "Link expiry",
  "workspace.shareLink.publicLinkLabel": "Public link",
  "workspace.shared.footer": "Shared with a public link.",
  "workspace.shared.footerExpires": "Shared with a public link · expires {date}",
  "workspace.shared.goneHint": "It may have expired, or the person who shared it may have revoked it. Ask them for a new link.",
  "workspace.shared.goneTitle": "This link is not available",
  "workspace.shared.openFile": "Open file",
  "workspace.shared.opening": "Opening…",
  "workspace.shared.updated": "updated {date}",
  "workspace.sidebar.agent.caesar": "Operations",
  "workspace.sidebar.agent.simone": "Builds your product",
  "workspace.sidebar.agent.temo": "Resolves your tasks",
  "workspace.sidebar.agent.watcher": "Analyzes usage",
  "workspace.sidebar.channels": "CHANNELS",
  "workspace.sidebar.directMessages": "DIRECT MESSAGES",
  "workspace.sidebar.event.untitled": "Event",
  "workspace.sidebar.moreActions": "More actions",
  "workspace.sidebar.moreOptions": "More options",
  "workspace.simone.copyFailed": "Copy failed",
  "workspace.simone.error.failed": "Sorry — that request failed.",
  "workspace.simone.turn.stopped": "You stopped this answer.",
  "workspace.simone.turn.reconnecting": "The connection dropped, but the work goes on. The answer will show here when it is ready.",
  "workspace.simone.turn.waitingForYou": "The connection dropped. A step above is waiting for your answer.",
  "workspace.simone.approval.expired": "This step did not run: the wait for your answer ended. Ask again to run it.",
  "workspace.simone.approval.notRun": "This step did not run: the conversation stopped before your answer. Ask again to run it.",
  "workspace.simone.approval.runAgain": "Run that step again",
  "workspace.simone.approval.runNowPrompt": "Please run this step now: {step}",
  "workspace.simone.error.failedWithMessage": "Sorry — that request failed ({message}).",
  "workspace.simone.error.localBridge": "Local bridge not connected ({url}) — start simone-bridge locally, or switch the target back to Workspace.",
  "workspace.simone.error.network": "Sorry — I couldn't reach the server. Check your connection and try again.",
  "workspace.simone.error.noWorkspace": "No active workspace — open or switch to a workspace to use AI here.",
  "workspace.simone.error.notReady": "AI service not ready — please retry in a moment.",
  "workspace.simone.error.stream": "The AI service didn't respond cleanly. Try again — if it keeps happening, switching models often helps.",
  "workspace.simone.error.agentInactive": "This agent is inactive.",
  "workspace.simone.images.defaultName": "image",
  "workspace.simone.images.empty": "empty",
  "workspace.simone.images.notAccepted": "not accepted",
  "workspace.simone.images.notReadable": "not a readable image",
  "workspace.simone.images.notSent": "Not sent: {list}.",
  "workspace.simone.images.tooLarge": "larger than {size}",
  "workspace.simone.images.tooMany": "more than {max} images in one message",
  "workspace.simone.images.totalTooLarge": "over the {size} total",
  "workspace.simone.images.unsupported": "an unsupported format ({type})",
  "workspace.simone.linkCopied": "Link copied",
  "workspace.simone.linkCopiedBody": "Workspace members can open this conversation from the link.",
  "workspace.simone.menu.remove": "Remove",
  "workspace.simone.menu.shareLink": "Share link",
  "workspace.simone.menu.star": "Star",
  "workspace.simone.menu.unstar": "Unstar",
  "workspace.simone.newChat": "New chat",
  "workspace.simone.newThread": "New thread",
  "workspace.simone.noBridge": "No bridge transport — initBridge has not been called yet.",
  "workspace.simone.notShareable": "Not shareable yet",
  "workspace.simone.notShareableBody": "Send a message first — the thread gets its link once it exists on the server.",
  "workspace.simone.shareFailed": "Share failed",
  "workspace.simone.shareFailedBody": "Could not share the conversation.",
  "workspace.simone.threadUnavailable": "This conversation is not available to you. It may be private, deleted or in another workspace. Ask its owner to share it.",
  "workspace.simone.threadUnavailableTitle": "Conversation not available",
  "workspace.simone.removeTitle": "Remove “{name}”?",
  "workspace.simone.removeFailed": "Could not remove the conversation",
  "workspace.story.joined": "{count} people joined",
  "workspace.story.meetingAt": "· at {time}",
  "workspace.story.plannedFor": "Planned for",
  "workspace.story.tickets": "TICKETS",
  "workspace.switch.slow": "Switch is taking too long",
  "workspace.switch.slowBody": "The workspace switch didn’t complete in time — some data may be stale. Try again or reload.",
  "workspace.system.corner.package": "Package",
  "workspace.system.corner.service": "Service",
  "workspace.system.error.detail": "Verify the GitHub status integration, then use Refresh to try again.",
  "workspace.system.error.title": "Status checks need attention",
  "workspace.system.grid.packages": "Packages",
  "workspace.system.grid.services": "Services",
  "workspace.system.infra.empty": "No uptime history has been reported yet.",
  "workspace.system.infra.period": "Last 120 days",
  "workspace.system.infra.title": "Infrastructure",
  "workspace.system.latency": "{ms} ms",
  "workspace.system.moreHealthActions": "More System Health actions",
  "workspace.system.noCheck": "No check recorded",
  "workspace.system.openDeployment": "Open the {repo} deployment on {env}",
  "workspace.system.page.title": "System Health / Admin",
  "workspace.system.refresh": "Refresh",
  "workspace.system.refreshAria": "Refresh System Health",
  "workspace.system.status.building": "Building",
  "workspace.system.status.degraded": "Degraded",
  "workspace.system.status.failed": "Failed",
  "workspace.system.status.healthy": "Healthy",
  "workspace.system.status.noData": "No data",
  "workspace.system.status.pending": "Pending",
  "workspace.system.status.probeError": "Probe error",
  "workspace.system.title": "System Health",
  "workspace.system.tone.allFailed": "Status service returned errors — every probe failed",
  "workspace.system.tone.empty": "No status data yet",
  "workspace.system.tone.error": "Status checks need attention",
  "workspace.system.tone.loading": "Fetching status...",
  "workspace.system.tone.ok": "All systems operational",
  "workspace.system.tone.partial": "Some probes failed — see details below",
  "workspace.teamAnswer.agent": "AI agent",
  "workspace.teamAnswer.empty": "No one matches.",
  "workspace.teamAnswer.failed": "Could not load the team.",
  "workspace.teamAnswer.group.agents": "AI agents · {count}",
  "workspace.teamAnswer.group.members": "Members · {count}",
  "workspace.teamAnswer.group.online": "Online now · {count}",
  "workspace.teamAnswer.noneOnline": "No one else is online right now.",
  "workspace.teamAnswer.online": "Online",
  "workspace.teamAnswer.show.agents": "AI agents",
  "workspace.teamAnswer.show.all": "Everyone",
  "workspace.teamAnswer.show.members": "Members",
  "workspace.teamAnswer.show.online": "Online now",
  "workspace.teamAnswer.title": "Team",
  "workspace.teamAnswer.you": "You",
  "workspace.teamTime.offHours": "Off hours",
  "workspace.teamTime.openAria": "Open {name}",
  "workspace.teamTime.profile": "profile",
  "workspace.teamTime.remote": "Remote",
  "workspace.teamTime.workingHours": "Working hours",
  "workspace.teamtime.empty": "No other teammates yet — invite your team to see their local time here.",
  "workspace.threadPicker.empty": "No saved threads yet",
  "workspace.threadPicker.new": "+ New thread",
  "workspace.threadPicker.switch": "Switch thread",
  "workspace.threadPicker.thread": "Thread",
  "workspace.ticket.untitled": "Untitled",
  "workspace.ticketState.awaitingApproval": "Awaiting approval",
  "workspace.ticketState.backlog": "Backlog",
  "workspace.ticketState.blocked": "Blocked",
  "workspace.ticketState.cancelled": "Cancelled",
  "workspace.ticketState.done": "Done",
  "workspace.ticketState.draft": "Draft",
  "workspace.ticketState.inProgress": "In progress",
  "workspace.ticketState.inReview": "In review",
  "workspace.ticketState.readyToTest": "Ready to test",
  "workspace.ticketState.released": "Released",
  "workspace.ticketState.todo": "To do",
  "workspace.unsaved.discardTitle": "Discard changes?",
  "workspace.unsaved.discardMessage": "A page you left open has changes that are not saved. If you discard them, the page closes.",
  "workspace.unsaved.discard": "Discard",
  "workspace.unsaved.keep": "Keep",
  "workspace.username.available": "Available.",
  "workspace.username.error.required": "Pick a username first.",
  "workspace.username.error.saveFailed": "Could not save the username. Try again.",
  "workspace.username.keepCurrent": "Keep current",
  "workspace.username.label": "Username",
  "workspace.username.rules": "Lowercase letters, numbers and dashes.",
  "workspace.username.subtitle": "It names you on your profile and in mentions. Keep the suggested one or make it yours.",
  "workspace.username.taken": "That username is taken.",
  "workspace.username.title": "Pick your username",
  "workspace.usernamePrompt.fieldLabel": "Username",
  "workspace.usernamePrompt.save": "Save username",
  "workspace.usernamePrompt.saving": "Saving…",
  "workspace.widget.action.createAgent": "Create agent",
  "workspace.widget.action.hide": "Hide this widget",
  "workspace.widget.activity.subtitle": "Standups, tasks, notes and calls — last 365 days",
  "workspace.widget.activity.title": "Your activity",
  "workspace.widget.agents.subtitle": "People + AI agents working alongside you",
  "workspace.widget.agents.title": "Team and agents",
  "workspace.widget.analytics.subtitle": "Who's on the workspace today",
  "workspace.widget.analytics.title": "Active right now",
  "workspace.widget.appAgents.subtitle": "AI agents",
  "workspace.widget.appAgents.title": "Agents",
  "workspace.widget.appAnalytics.subtitle": "Insights",
  "workspace.widget.appAnalytics.title": "Analytics",
  "workspace.widget.appBroadcast.subtitle": "Announcements",
  "workspace.widget.appBroadcast.title": "Broadcast",
  "workspace.widget.appCalendar.subtitle": "Schedule",
  "workspace.widget.appCalendar.title": "Calendar",
  "workspace.widget.appChat.subtitle": "Team messages",
  "workspace.widget.appChat.title": "Chat",
  "workspace.widget.appDocuments.subtitle": "Notes & knowledge",
  "workspace.widget.appDocuments.title": "Notes",
  "workspace.widget.appHealth.subtitle": "Operations",
  "workspace.widget.appHealth.title": "System Health",
  "workspace.widget.appInfra.subtitle": "Services and status",
  "workspace.widget.appInfra.title": "Infrastructure",
  "workspace.widget.appMeet.subtitle": "Video rooms",
  "workspace.widget.appMeet.title": "Meet",
  "workspace.widget.appPeople.subtitle": "Members",
  "workspace.widget.appPeople.title": "People",
  "workspace.widget.appReminders.title": "Reminders",
  "workspace.widget.appStudio.subtitle": "Design canvas",
  "workspace.widget.appStudio.title": "Apps",
  "workspace.widget.appTeam.subtitle": "Team & agents",
  "workspace.widget.appTeam.title": "Team",
  "workspace.widget.appTickets.subtitle": "Tasks & board",
  "workspace.widget.appTickets.title": "Tasks",
  "workspace.widget.assets.subtitle": "Files and documents in this workspace",
  "workspace.widget.assets.title": "Notes",
  "workspace.widget.broadcast.subtitle": "Messages to the whole workspace",
  "workspace.widget.broadcast.title": "Broadcast",
  "workspace.widget.deleteFailed": "Could not delete widget",
  "workspace.widget.deleted": "“{title}” deleted",
  "workspace.widget.events.title": "Coming up",
  "workspace.widget.genericError": "Something went wrong — try again.",
  "workspace.widget.given.bodyEmpty": "You haven't delegated any open tasks.",
  "workspace.widget.given.bodyError": "Couldn’t load delegated tasks — reload to try again.",
  "workspace.widget.given.subtitleError": "Couldn’t load delegated tasks",
  "workspace.widget.given.title": "Given tasks",
  "workspace.widget.madePersonal": "“{title}” made personal",
  "workspace.widget.mailInbox.compose": "Compose",
  "workspace.widget.mailInbox.empty": "No mail in your inbox.",
  "workspace.widget.mailInbox.noSubject": "(no subject)",
  "workspace.widget.mailInbox.title": "Inbox",
  "workspace.widget.nextUp.empty": "Nothing coming up",
  "workspace.widget.nextUp.error": "Couldn't load the calendar.",
  "workspace.widget.nextUp.inHours": "in {n} h",
  "workspace.widget.nextUp.inMinutes": "in {n} min",
  "workspace.widget.nextUp.newBooking": "New booking",
  "workspace.widget.nextUp.title": "Next up",
  "workspace.widget.personalMessage": "Only you can see it now.",
  "workspace.widget.prioritymix.title": "Priority mix",
  "workspace.widget.prioritymix.toTriage": "{count} to triage",
  "workspace.widget.received.bodyEmpty": "Nothing assigned to you right now.",
  "workspace.widget.received.bodyError": "Couldn’t load your tasks — reload to try again.",
  "workspace.widget.received.subtitleError": "Couldn’t load your tasks",
  "workspace.widget.received.title": "Received tasks",
  "workspace.widget.shared": "“{title}” shared",
  "workspace.widget.sharedMessage": "Every workspace member with data access can now see it.",
  "workspace.widget.teampulse.title": "Team pulse",
  "workspace.widget.teamtime.subtitle": "Where everyone is right now",
  "workspace.widget.teamtime.title": "Team timezones",
  "workspace.widget.untitled": "Widget",
  "workspace.widget.changeWithAiPrefix": "Change “{title}”: ",
  "workspace.widget.changeWithAiKey": "Home widget “{title}”",
  "workspace.widget.updateFailed": "Could not update widget",
  "workspace.widget.workload.title": "Workload",
  "workspace.widget.youragents.title": "Your agents",
  "workspace.widgetColor.appColor": "App color",
  "workspace.widgetColor.default": "Default (no color)",
  "workspace.widgetColor.pickerAria": "Widget color",
  "workspace.widgetColor.suggested": "Suggested colors",
  "workspace.workload.captionEmpty": "nothing assigned",
  "workspace.workload.captionTop": "on {name}",
  "workspace.workload.more": "{count} more",
  "workspace.workload.unassignedCount": "{count} unassigned",
  "workspace.wysiwyg.blockquote": "Blockquote",
  "workspace.wysiwyg.bold": "Bold",
  "workspace.wysiwyg.bulletList": "Bullet list",
  "workspace.wysiwyg.code": "Code",
  "workspace.wysiwyg.divider": "Divider",
  "workspace.wysiwyg.italic": "Italic",
  "workspace.wysiwyg.link": "Link",
  "workspace.wysiwyg.numberedList": "Numbered list",
  "workspace.wysiwyg.strikethrough": "Strikethrough",
  "workspace.wysiwyg.underline": "Underline",
  "workspace.aiAware.canvasBoard": "Canvas board",
  "workspace.aiAware.canvasItems": "{name} · {count} items",
  "workspace.aiAware.canvasItemsOne": "{name} · 1 item",
  "workspace.aiAware.designSystem": "Design system · {name}",
  "workspace.aiAware.element": "element",
  "workspace.aiAware.home": "Home",
  "workspace.aiAware.image": "Image",
  "workspace.aiAware.page.calendar": "Calendar",
  "workspace.aiAware.page.chat": "Chat",
  "workspace.aiAware.page.files": "Files",
  "workspace.aiAware.page.history": "History",
  "workspace.aiAware.page.meet": "Meet",
  "workspace.aiAware.page.notes": "Notes",
  "workspace.aiAware.page.tasks": "Tasks",
  "workspace.aiAware.page.terminal": "Terminal",
  "workspace.aiAware.rows.activityOne": "1 activity event",
  "workspace.aiAware.rows.activity": "{count} activity events",
  "workspace.aiAware.rows.activityOfTotal": "{count} of {total} activity events",
  "workspace.aiAware.rows.channels": "{count} channels",
  "workspace.aiAware.rows.channelsOfTotal": "{count} of {total} channels",
  "workspace.aiAware.rows.channelsOne": "1 channel",
  "workspace.aiAware.rows.columns": "{count} columns",
  "workspace.aiAware.rows.columnsOfTotal": "{count} of {total} columns",
  "workspace.aiAware.rows.columnsOne": "1 column",
  "workspace.aiAware.rows.documents": "{count} documents",
  "workspace.aiAware.rows.documentsOfTotal": "{count} of {total} documents",
  "workspace.aiAware.rows.documentsOne": "1 document",
  "workspace.aiAware.rows.events": "{count} events",
  "workspace.aiAware.rows.eventsOfTotal": "{count} of {total} events",
  "workspace.aiAware.rows.eventsOne": "1 event",
  "workspace.aiAware.rows.files": "{count} files",
  "workspace.aiAware.rows.filesOfTotal": "{count} of {total} files",
  "workspace.aiAware.rows.filesOne": "1 file",
  "workspace.aiAware.rows.notes": "{count} notes",
  "workspace.aiAware.rows.notesOfTotal": "{count} of {total} notes",
  "workspace.aiAware.rows.notesOne": "1 note",
  "workspace.aiAware.rows.rooms": "{count} rooms",
  "workspace.aiAware.rows.roomsOfTotal": "{count} of {total} rooms",
  "workspace.aiAware.rows.roomsOne": "1 room",
  "workspace.aiAware.rows.tickets": "{count} tickets",
  "workspace.aiAware.rows.ticketsOfTotal": "{count} of {total} tickets",
  "workspace.aiAware.rows.ticketsOne": "1 ticket",
  "workspace.aiAware.scopeOrg": "org “{name}”",
  "workspace.aiAware.scopeTools": "workspace tools",
  "workspace.aiAware.scopeWorkspace": "Workspace “{name}”",
  "workspace.sharedResource.untitled": "Shared item",
  "workspace.aiWidget.notice.noAccess": "You do not have access to the data this widget shows.",
  "workspace.aiWidget.notice.sourceGone": "This widget reads a source that is no longer available.",
  "workspace.home.summary.eventOne": "1 event today",
  "workspace.home.summary.eventOther": "{count} events today",
  "workspace.home.summary.mailOne": "1 unread email",
  "workspace.home.summary.mailOther": "{count} unread emails",
  "workspace.home.summary.notifOne": "1 unread notification in this workspace",
  "workspace.home.summary.notifOther": "{count} unread notifications in this workspace",
  "workspace.home.summary.none": "Nothing needs you right now.",
  "workspace.home.summary.sentence": "You have {facts}.",
  "workspace.home.summary.two": "{a} and {b}",
  "workspace.home.summary.three": "{a}, {b} and {c}",
  "workspace.home.summary.taskOne": "1 open task",
  "workspace.home.summary.taskOther": "{count} open tasks",
  "workspace.home.signals.taskOverdueOne": "1 overdue task",
  "workspace.home.signals.taskOverdueOther": "{count} overdue tasks",
  "workspace.home.signals.urgent": "Urgent",
  "workspace.home.signals.attention": "Needs attention",
  "workspace.home.brief.label": "Summary",
  "workspace.home.brief.waiting": "Waiting on you: {facts}.",
  "workspace.home.brief.also": "You also have {facts}.",
  "workspace.home.brief.from": "from {time}",
  "workspace.home.brief.updated": "Updated {time}",
  "workspace.home.brief.openAsBoard": "Open as board",
  "workspace.home.brief.boardPrompt": "Make a board of what needs me today: {facts}.",
  "workspace.widget.action.add": "Add",
  "workspace.widget.size.label": "Widget size",
  "workspace.aiScope.overview": "Overview",
  "workspace.aiScope.kindWorkspace": "Workspace",
  "workspace.aiScope.group.suggested": "Suggested",
  "workspace.aiScope.group.suggestedFor": "Suggested for {name}",
  "workspace.aiScope.group.recent": "Recent",
  "workspace.aiScope.intent.attention": "What needs attention here?",
  "workspace.aiScope.intent.attentionPrompt": "What needs attention here ({name})? List what needs action first, and say why.",
  "workspace.aiScope.intent.attentionApp": "What needs attention in {name}?",
  "workspace.aiScope.intent.attentionAppPrompt": "What needs attention in {name} right now? List what needs action first, and say why.",
  "workspace.aiScope.action.inspect": "Inspect & ask",
  "workspace.aiScope.action.inspectHint": "Point at a widget or a section and ask about it",
  "workspace.aiScope.action.summarize": "Summarize",
  "workspace.aiScope.action.summarizeHint": "Summarize {name}",
  "workspace.aiScope.action.board": "Build a board",
  "workspace.aiScope.action.boardHint": "Build a board for {name}",
  "workspace.aiScope.action.summarizePromptRecord": "Summarize {name}: what it is, where it stands and what comes next.",
  "workspace.aiScope.action.summarizePromptPage": "Summarize this page ({name}): the key figures, what changed and what needs attention.",
  "workspace.aiScope.action.summarizePromptApp": "Summarize {name}: the key figures, what changed and what needs attention.",
  "workspace.aiScope.action.summarizePromptWorkspace": "Summarize the {name} workspace: the key figures across its apps, what changed and what needs attention.",
  "workspace.aiScope.action.boardPromptRecord": "Build a board about {name}.",
  "workspace.aiScope.action.boardPromptPage": "Build a board from this page ({name}).",
  "workspace.aiScope.action.boardPromptApp": "Build a board for {name}.",
  "workspace.aiScope.action.boardPromptWorkspace": "Build a board for the {name} workspace.",
  "workspace.aiInspect.hint": "Point at a widget or a section, then click to ask about it.",
  "workspace.aiInspect.pick": "Ask about this",
  "workspace.aiInspect.untitled": "Selected part",
  "workspace.aiCap.title": "What I can do for {name}",
  "workspace.aiCap.intro": "Here is what I can do for {name}. Tap any line.",
  "workspace.aiCap.ask": "Ask",
  "workspace.aiCap.askExplain": "Questions I answer from the live data here",
  "workspace.aiCap.askFallback": "What is going on here?",
  "workspace.aiCap.askFallbackPrompt": "What is going on in {name}? Give me the key figures and what changed.",
  "workspace.aiCap.do": "Do",
  "workspace.aiCap.doExplain": "Changes I prepare for you. Nothing runs until you approve it.",
  "workspace.aiCap.doPrompt": "Help me with this: {action}. Ask me for what you need, then propose it for my approval.",
  "workspace.aiCap.build": "Build",
  "workspace.aiCap.buildExplain": "Boards and widgets I can make from this data",
  "workspace.aiCap.buildBoard": "A board for {name}",
  "workspace.aiCap.buildBoardPrompt": "Build a board for {name}.",
  "workspace.aiCap.buildWidgetPrompt": "Build a board with the {widget} widget.",
  "workspace.aiCap.inspect": "Inspect",
  "workspace.aiCap.inspectExplain": "Point at any widget or section and ask about it",
  "workspace.aiCap.inspectStart": "Start inspecting",
  "workspace.onboarding.welcomeTitle": "Welcome, {name}",
  "workspace.onboarding.welcomeTitleNoName": "Welcome",
  "workspace.onboarding.welcomeLead": "Let’s make {workspace} feel like home. A few simple choices, and you’re ready to go.",
  "workspace.onboarding.wayAssistant": "Set up with the assistant",
  "workspace.onboarding.wayAssistantHint": "Answer a few quick questions. Each answer applies right away.",
  "workspace.onboarding.wayTour": "Take a quick tour",
  "workspace.onboarding.wayTourHint": "A one-minute look at where everything is.",
  "workspace.onboarding.replayHint": "Come back anytime: avatar menu → Replay onboarding.",
  "workspace.onboarding.replayCaption": "Getting started",
  "workspace.onboarding.replayAssistant": "Set up with the assistant",
  "workspace.onboarding.replayTour": "Take the tour",
  "workspace.onboarding.chat.title": "Set up your workspace",
  "workspace.onboarding.chat.progress": "Question {n} of {total}",
  "workspace.onboarding.chat.hello": "Hi {name}! I'll help you set up your workspace. Each answer applies right away, and you can skip any question.",
  "workspace.onboarding.chat.helloNoName": "Hi! I'll help you set up your workspace. Each answer applies right away, and you can skip any question.",
  "workspace.onboarding.chat.languageSet": "This workspace uses {language}. Your workspace admin chooses its language.",
  "workspace.onboarding.chat.keepThis": "Keep it as it is",
  "workspace.onboarding.chat.askTheme": "Do you like light or dark? Auto follows your device.",
  "workspace.onboarding.chat.askSky": "Pick a background for your home.",
  "workspace.onboarding.chat.askSummary": "How should your home sum up your day?",
  "workspace.onboarding.chat.summaryBriefHint": "Two calm sentences about what needs you.",
  "workspace.onboarding.chat.summarySignalsHint": "Four tiles with the numbers that matter.",
  "workspace.onboarding.chat.askStrip": "Where should your app shortcuts go?",
  "workspace.onboarding.chat.stripDock": "Above the widgets",
  "workspace.onboarding.chat.stripDockHint": "One row of apps under the greeting.",
  "workspace.onboarding.chat.stripRail": "Beside the widgets",
  "workspace.onboarding.chat.stripRailHint": "A slim column of apps at the side.",
  "workspace.onboarding.chat.stripOff": "Hide them",
  "workspace.onboarding.chat.stripOffHint": "Open apps from the navbar only.",
  "workspace.onboarding.chat.askTour": "All set! Do you want a quick tour of where everything is?",
  "workspace.onboarding.chat.tourYes": "Start the tour",
  "workspace.onboarding.chat.tourNo": "No, thanks",
  "workspace.onboarding.chat.bye": "You are all set. Change any of this in Customize dashboard, or just ask me.",
  "workspace.onboarding.chat.notSaved": "That one did not save. You can change it later in the settings.",
  "workspace.onboarding.chat.skipQuestion": "Skip",
  "workspace.onboarding.chat.skipSetup": "Skip setup",
  "workspace.onboarding.chat.finish": "Start working",
  "workspace.onboarding.chat.askLabel": "Ask the assistant",
  "workspace.onboarding.chat.askPlaceholder": "Ask the assistant anything…",
  "workspace.onboarding.chat.askSend": "Send to the assistant",
  "workspace.onboarding.tour.counter": "Step {n} of {total}",
  "workspace.onboarding.tour.close": "Close the tour",
  "workspace.onboarding.tour.skip": "Skip tour",
  "workspace.onboarding.tour.done": "Done",
  "workspace.onboarding.tour.appsTitle": "Your apps",
  "workspace.onboarding.tour.appsText": "Every app of this workspace is one click away. The arrow opens the rest.",
  "workspace.onboarding.tour.searchTitle": "Search everything",
  "workspace.onboarding.tour.searchText": "Find people, tasks, files and messages from anywhere.",
  "workspace.onboarding.tour.inboxTitle": "Stay in touch",
  "workspace.onboarding.tour.inboxText": "Your direct messages, calls and notifications are here.",
  "workspace.onboarding.tour.accountTitle": "Your account",
  "workspace.onboarding.tour.accountText": "Your profile, settings, theme and dashboard controls live here. Choose Replay onboarding whenever you want another walkthrough.",
  "workspace.onboarding.tour.stripTitle": "Quick launch",
  "workspace.onboarding.tour.stripText": "Your apps, one press away. Reorder them in Customize dashboard.",
  "workspace.onboarding.tour.composerTitle": "Ask the assistant",
  "workspace.onboarding.tour.composerText": "Ask a question, or ask it to do something: find a file, create a task, build a page.",
  "workspace.onboarding.tour.endEyebrow": "Tour",
  "workspace.onboarding.tour.endTitle": "That's the tour",
  "workspace.onboarding.tour.endText": "Explore at your own pace. Come back anytime: avatar menu → Replay onboarding.",
  "workspace.onboarding.tour.appsTextPhone": "The Apps button opens every app of this workspace.",
  "workspace.onboarding.tour.accountTextPhone": "Your account, search and your workspaces are in this menu.",
  "workspace.onboarding.tour.composerTextPhone": "This button opens the assistant. Ask a question, or ask it to do something.",
  "workspace.onboarding.replayWizard": "Run the setup again",
  "workspace.onboarding.wizard.start": "Get started",
  "workspace.onboarding.wizard.next": "Continue",
  "workspace.onboarding.wizard.back": "Back",
  "workspace.onboarding.wizard.progress": "Step {n} of {total}",
  "workspace.onboarding.wizard.preparing": "Loading your preferences…",
  "workspace.onboarding.wizard.otherWays": "Or start another way",
  "workspace.onboarding.wizard.appsTitle": "What belongs in your day?",
  "workspace.onboarding.wizard.appsLead": "Keep your everyday tools close.",
  "workspace.onboarding.wizard.appsAll": "Select all",
  "workspace.onboarding.wizard.appsNone": "Clear",
  "workspace.onboarding.wizard.appsCount": "{n} of {total} picked",
  "workspace.onboarding.wizard.lookTitle": "Find your kind of calm.",
  "workspace.onboarding.wizard.lookLead": "A theme for your screen and a background for your home.",
  "workspace.onboarding.wizard.themeAutoHint": "Follows your device",
  "workspace.onboarding.wizard.homeTitle": "A home that works for you.",
  "workspace.onboarding.wizard.homeLead": "Start with a style, then choose where your shortcuts live.",
  "workspace.onboarding.wizard.doneTitle": "Make yourself at home.",
  "workspace.onboarding.wizard.doneLead": "Your choices are in place. Start exploring — you can keep shaping your space as you go.",
  "workspace.onboarding.wizard.workTitle": "Your work",
  "workspace.onboarding.wizard.workLead": "What does your business do? A preset adds the apps, channels and folders it needs. It only adds; nothing is removed.",
  "workspace.onboarding.wizard.stackTitle": "Your apps",
  "workspace.onboarding.wizard.stackLead": "These apps come with {preset}. Untick the ones you do not need, and tick any suggested app you want.",
  "workspace.onboarding.wizard.stackLeadCustom": "Tick the apps your workspace needs.",
  "workspace.onboarding.wizard.ideaTitle": "Your idea",
  "workspace.onboarding.wizard.ideaLead": "Need an app we don't have? Describe it in one sentence.",
  "workspace.onboarding.wizard.buildIdea": "Build my app",
  "workspace.onboarding.wizard.doneIdea": "Your idea: {idea}",
  "workspace.onboarding.work.custom": "Something else",
  "workspace.onboarding.work.customHint": "Pick your own apps from the App Store.",
  "workspace.onboarding.work.more": "More kinds of work",
  "workspace.onboarding.work.moreHint": "See every industry that has a preset.",
  "workspace.onboarding.work.applied": "Set up for {preset}",
  "workspace.onboarding.work.appliedCustom": "Set up as a custom workspace",
  "workspace.onboarding.work.appliedOther": "Set up from a preset",
  "workspace.onboarding.work.applying": "Setting up {preset}…",
  "workspace.onboarding.work.applyingCustom": "Setting up your apps…",
  "workspace.onboarding.work.loading": "Loading the presets…",
  "workspace.onboarding.stack.loading": "Loading the apps…",
  "workspace.onboarding.stack.none": "There are no apps to pick here yet.",
  "workspace.onboarding.stack.browse": "Find more in the App Store",
  "workspace.onboarding.idea.label": "Your app idea",
  "workspace.onboarding.idea.placeholder": "An app that…",
  "workspace.onboarding.idea.examples": "Examples",
  "workspace.onboarding.idea.example1": "A form where clients book a call and pay a deposit",
  "workspace.onboarding.idea.example2": "A list of the equipment we lend out, and when each piece comes back",
  "workspace.onboarding.idea.example3": "A weekly report of the hours my team spends on each client",
  "workspace.onboarding.idea.note": "Building starts when you finish and uses AI credits.",
  "workspace.onboarding.setup.doneCustom": "Your apps are ready.",
  "workspace.onboarding.setup.partialCustom": "Some apps could not install. Try again to add them.",
  "workspace.onboarding.chat.askWork": "First: what does your business do? A preset sets up the apps, channels and folders it needs.",
  "workspace.onboarding.chat.askIdea": "Need an app we don't have? Describe it in one sentence, or skip this.",
  "workspace.onboarding.chat.ideaNext": "Got it. We start building it when you finish.",
  "workspace.onboarding.chat.workSet": "This workspace is already set up for {preset}.",
  "workspace.onboarding.chat.workSetCustom": "This workspace is already set up with the apps you picked.",
  "workspace.onboarding.chat.workSetOther": "This workspace is already set up for your work.",
  "workspace.appsHub.title": "Workspace apps",
  "workspace.appsHub.lede": "Add-ons that run inside this workspace. Your team opens them from the apps menu.",
  "workspace.appsHub.buildWithAi": "Build with AI",
  "workspace.appsHub.browseStore": "Browse App Store",
  "workspace.appsHub.section.installed": "Installed",
  "workspace.appsHub.section.team": "Built by your team",
  "workspace.appsHub.section.store": "From the App Store",
  "workspace.appsHub.source.store": "App Store",
  "workspace.appsHub.source.ai": "Built with AI",
  "workspace.appsHub.source.custom": "Custom",
  "workspace.appsHub.state.notInstalled": "Not installed",
  "workspace.appsHub.channel.production": "Production",
  "workspace.appsHub.channel.development": "Development",
  "workspace.appsHub.action.open": "Open",
  "workspace.appsHub.action.edit": "Edit",
  "workspace.appsHub.action.manage": "Manage",
  "workspace.appsHub.empty.title": "No workspace apps yet",
  "workspace.appsHub.empty.body": "Install an app from the App Store or build one with AI.",
  "workspace.appsHub.toWebsites": "Building a public website? Open Websites",
  "workspace.widget.websites.title": "Websites",
  "workspace.widget.deleteTitle": "Delete “{title}”?",
  "workspace.widget.deleteSharedMessage": "It is shared to the workspace: it goes for everyone who sees it. You cannot bring it back.",
  "workspace.agentMode.frameLabel": "Agent mode",
  "workspace.agentMode.leave": "Leave Agent mode",
  "workspace.agentMode.leaveShort": "Leave",
  "workspace.agentMode.ui": "Human",
  "workspace.agentMode.cli": "Agent",
  "workspace.agentMode.switchLabel": "Human / Agent",
  "workspace.agentMode.toggle": "Switch between Human and Agent (Ctrl+`)",
  "workspace.agentMode.views": "Views",
  "workspace.agentMode.apps": "Apps",
  "workspace.agentMode.askAi": "Ask AI",
  "workspace.agentMode.filter": "Filter",
  "workspace.agentMode.loading": "Loading {view}…",
  "workspace.agentMode.retryKeys": "r retry  esc back",
  "workspace.agentMode.nothingHere": "Nothing here yet.",
  "workspace.agentMode.nothingMatches": "Nothing matches \"{query}\".",
  "workspace.agentMode.nothingYet": "Nothing yet.",
  "workspace.agentMode.partsFailed": "{count} part(s) could not load. Press r to retry.",
  "workspace.agentMode.channels": "Channels",
  "workspace.agentMode.pickChannel": "Pick a channel.",
  "workspace.agentMode.noChannels": "No channels yet.",
  "workspace.agentMode.noMessages": "No messages yet. Say hello.",
  "workspace.agentMode.writeIn": "Press ⏎ to write in {channel}",
  "workspace.agentMode.writeMessage": "Write a message",
  "workspace.agentMode.assistantTitle": "Ask the workspace assistant",
  "workspace.agentMode.assistantHint": "Type in the ASK AI bar below. Press a from any app to start.",
  "workspace.agentMode.you": "You",
  "workspace.agentMode.ai": "AI",
  "workspace.agentMode.stopped": "Stopped.",
  "workspace.agentMode.assistantFailed": "The assistant failed.",
  "workspace.agentMode.noMatches": "No matches.",
  "workspace.agentMode.hintPicker": "↑↓ ⏎ esc",
  "workspace.agentMode.hintForm": "tab next  ^S save  esc cancel",
  "workspace.agentMode.hintConfirm": "y / n",
  "workspace.agentMode.hintHelp": "esc close",
  "workspace.agentMode.startFailed": "Agent mode could not start. Choose Human above to return.",
  "workspace.onboarding.learn.welcomeTitle": "A familiar place for a fresh start.",
  "workspace.onboarding.learn.welcomeText": "Your apps, your daily overview, and a helpful assistant — together in one workspace.",
  "workspace.onboarding.learn.appsTitle": "Your everyday essentials, within reach.",
  "workspace.onboarding.learn.appsText": "Choose the apps you use most. You can find every available app in All apps whenever you need it.",
  "workspace.onboarding.learn.lookTitle": "Make room for a little personality.",
  "workspace.onboarding.learn.lookText": "These choices are just for you. Auto follows your device’s light or dark appearance.",
  "workspace.onboarding.learn.homeTitle": "A calmer start to every day.",
  "workspace.onboarding.learn.homeText": "Widgets give you a quick view of your work. Open one to go deeper, and use Customize dashboard to arrange them.",
  "workspace.onboarding.learn.doneTitle": "Ready when you are.",
  "workspace.onboarding.learn.doneText": "Try the quick tour to find your way around, or open an app and make your first move.",
  "workspace.onboarding.learn.assistantTitle": "A little help goes a long way.",
  "workspace.onboarding.learn.assistantText": "Pick an answer to personalize your space, or ask the assistant a question in your own words.",
  "workspace.onboarding.learn.workTitle": "This part is for the whole workspace.",
  "workspace.onboarding.learn.stackTitle": "Apps for the whole team.",
  "workspace.onboarding.learn.ideaTitle": "An app made for your work.",
  "workspace.onboarding.journey.label": "Your setup journey",
  "workspace.onboarding.journey.apps": "Essentials",
  "workspace.onboarding.journey.look": "Your look",
  "workspace.onboarding.journey.home": "Your home",
  "workspace.onboarding.journey.work": "Your work",
  "workspace.onboarding.journey.stack": "Your apps",
  "workspace.onboarding.journey.idea": "Your idea",
  "workspace.onboarding.journey.sideWorkspace": "For the workspace",
  "workspace.onboarding.journey.sidePersonal": "For you",
  "workspace.onboarding.ready.title": "Your workspace is ready",
  "workspace.onboarding.ready.lead": "Fly, the Symbols setup assistant, set up {workspace} with you.",
  "workspace.onboarding.ready.leadNoName": "Fly, the Symbols setup assistant, set up your workspace with you.",
  "workspace.onboarding.ready.made": "What is ready",
  "workspace.onboarding.ready.more": "{count} more apps",
  "workspace.onboarding.ready.moreOne": "1 more app",
  "workspace.onboarding.ready.siteDefault": "Website",
  "workspace.onboarding.ready.ideaBuilding": "Building now",
  "workspace.onboarding.preset.caption": "How do you like to start your day?",
  "workspace.onboarding.preset.focus": "Keep me focused",
  "workspace.onboarding.preset.focusHint": "A calm written brief, with your apps close by.",
  "workspace.onboarding.preset.overview": "Give me the overview",
  "workspace.onboarding.preset.overviewHint": "Key numbers at a glance, with your apps close by.",
  "workspace.onboarding.studio.eyebrow": "A space for you",
  "workspace.onboarding.studio.title": "Your work.\nYour rhythm.",
  "workspace.onboarding.studio.prompt": "Ask, find, or start something…",
  "workspace.onboarding.studio.caption": "A preview of your home. Your choices bring it to life.",
  "workspace.addApp.chat.placeholder": "Describe your app, a workflow, or an idea…",
  "workspace.addApp.chat.idea1": "Task board",
  "workspace.addApp.chat.idea2": "Meeting dashboard",
  "workspace.addApp.chat.idea3": "Team directory",
  "workspace.addApp.chat.idea4": "Notes hub",
  "workspace.addApp.catalog.browse": "Browse apps",
  "workspace.addApp.catalog.back": "Back to build",
  "workspace.pobBuild.title": "Setting up {workspace}",
  "workspace.pobBuild.titleNoName": "Setting up your workspace",
  "workspace.pobBuild.lead": "Each card is a step we really did. It ticks when the step is done.",
  "workspace.pobBuild.stepWorkspace": "Your workspace",
  "workspace.pobBuild.stepProfile": "Your company profile",
  "workspace.pobBuild.stepApps": "Your apps",
  "workspace.pobBuild.stepRecords": "Your first records",
  "workspace.pobBuild.stepSite": "Your website",
  "workspace.pobBuild.workspaceDone": "Workspace created",
  "workspace.pobBuild.profileDone": "We filled {count} profile fields from your website.",
  "workspace.pobBuild.profileDoneOne": "We filled 1 profile field from your website.",
  "workspace.pobBuild.appsDone": "Installed {count} apps",
  "workspace.pobBuild.appsDoneOne": "Installed 1 app",
  "workspace.pobBuild.appsSomeFailed": "Some apps did not install.",
  "workspace.pobBuild.recordsDone": "Added {count} records",
  "workspace.pobBuild.recordsDoneOne": "Added 1 record",
  "workspace.pobBuild.siteDone": "Your site draft is ready",
  "workspace.pobBuild.done": "Done",
  "workspace.pobBuild.notDone": "Not done",
  "workspace.pobBuild.running": "Working…",
  "workspace.pobBuild.pending": "Waiting…",
  "workspace.pobBuild.skipped": "Skipped",
  "workspace.pobBuild.offered": "We found {count} products and services. You can import them next.",
  "workspace.pobBuild.offeredOne": "We found 1 product or service. You can import it next.",
  "workspace.pobBuild.offeredNone": "What we found waits for you as an import.",
  "workspace.pobBuild.noOfferings": "We found no products or services on your website.",
  "workspace.pobBuild.sitePending": "Your website offer waits for you in the assistant.",
  "workspace.pobBuild.noSite": "We found no website to read.",
  "workspace.pobBuild.noPreset": "No apps to install.",
  "workspace.pobBuild.researchDeleted": "You deleted the research.",
  "workspace.pobBuild.researchExpired": "The read of your website expired before sign-up.",
  "workspace.pobBuild.researchNotDone": "The read of your website did not finish.",
  "workspace.pobBuild.noResearch": "We did not read a website for this workspace.",
  "workspace.pobBuild.see": "Open",
  "workspace.pobBuild.seeApps": "See your apps",
  "workspace.pobBuild.retryRefused": "This step cannot run again.",
  "workspace.pobBuild.retryFailed": "Could not try again. Try again later.",
  "workspace.pobBuild.timedOut": "Some steps still run. They go on while you work.",
  "workspace.pobBuild.ready": "Your workspace is ready",
  "workspace.pobBuild.open": "Open my workspace",
  "workspace.pobThread.read": "What I read on {domain}",
  "workspace.pobThread.readNoDomain": "What I read on your website",
  "workspace.pobThread.profile": "Filled {count} fields of your company profile",
  "workspace.pobThread.profileOne": "Filled 1 field of your company profile",
  "workspace.pobThread.from": "from {place}",
  "workspace.pobThread.review": "Review what I read",
  "workspace.pobThread.reviewHide": "Hide what I read",
  "workspace.pobThread.reviewDone": "Done",
  "workspace.pobThread.reviewFailed": "Your review was not saved. Try again.",
  "workspace.pobThread.delete": "Delete all research",
  "workspace.pobThread.deleteTitle": "Delete all research?",
  "workspace.pobThread.deleteMessage": "This deletes what research added: the profile values you did not change, the records it added and the people it found. Your workspace and your apps stay.",
  "workspace.pobThread.deleted": "Research deleted: {fields} profile fields, {records} records, {people} people.",
  "workspace.pobThread.deleteFailed": "The research was not deleted. Try again.",
  "workspace.pobThread.deleteLine": "Delete: {line}",
  "workspace.pobThread.deleteLineTitle": "Delete this part of the research?",
  "workspace.pobThread.deleteLineMessage": "This deletes one part of what research added: {line}. The rest of the research, your workspace and your apps stay.",
  "workspace.pobThread.lineDeleted": "Deleted: {line}.",
  "workspace.pobThread.offers": "Three things wait for you. Nothing starts until you start it.",
  "workspace.pobThread.soon": "Soon",
  "workspace.pobThread.website": "Website",
  "workspace.pobThread.websiteLead": "A website plan from what I read on {domain}.",
  "workspace.pobThread.websiteLeadNone": "A website plan for your business.",
  "workspace.pobThread.team": "Team",
  "workspace.pobThread.teamLead": "I found {count} people on {page}.",
  "workspace.pobThread.teamLeadOne": "I found 1 person on {page}.",
  "workspace.pobThread.teamLeadNone": "Invite the people you work with.",
  "workspace.pobThread.teamAction": "Invite your team",
  "workspace.pobThread.imports": "Imports",
  "workspace.pobThread.importsLeadNone": "Bring in a file or a table you already have.",
  "workspace.pobThread.importsAction": "Start an import",
  "workspace.pobThread.checklist": "Getting started",
  "workspace.pobThread.checkProfile": "Review your profile",
  "workspace.pobThread.checkWebsite": "Plan your website",
  "workspace.pobThread.checkTeam": "Invite your team",
  "workspace.pobThread.checkImport": "Import your data",
  "workspace.pobThread.itemDone": "Done",
  "workspace.pobThread.itemOpen": "Not done yet",
  "workspace.pobThread.progress": "{n} of {total} done",
  "workspace.gettingStarted.team.title": "Invite your team",
  "workspace.gettingStarted.team.foundOn": "Found on",
  "workspace.gettingStarted.team.why": "Why do I see this?",
  "workspace.gettingStarted.team.whyText": "We read the names and roles on {page}. We did not look anywhere else. Rows you do not use are deleted after 30 days.",
  "workspace.gettingStarted.team.listAria": "People found on your site",
  "workspace.gettingStarted.team.switchAria": "Invite {name}",
  "workspace.gettingStarted.team.emailPlaceholder": "Type their e-mail",
  "workspace.gettingStarted.team.emailAria": "E-mail of {name}",
  "workspace.gettingStarted.team.company": "Company e-mail",
  "workspace.gettingStarted.team.remove": "Remove",
  "workspace.gettingStarted.team.removeAria": "Remove {name} from this list",
  "workspace.gettingStarted.team.invited": "Invited",
  "workspace.gettingStarted.team.sent": "Invite sent",
  "workspace.gettingStarted.team.failed": "This invite did not go out. Try again.",
  "workspace.gettingStarted.team.invalidEmail": "This e-mail address is not valid.",
  "workspace.gettingStarted.team.removeFailed": "We could not remove this row. Try again.",
  "workspace.gettingStarted.team.other": "Invite someone else by e-mail",
  "workspace.gettingStarted.team.otherPlaceholder": "Type an e-mail",
  "workspace.gettingStarted.team.domainJoin": "Anyone with an @{domain} e-mail can join (they ask, you approve)",
  "workspace.gettingStarted.team.domainJoinFailed": "The setting did not save. Try again.",
  "workspace.gettingStarted.team.domainNotEligible": "Only an owner with a verified @{domain} e-mail can turn this on.",
  "workspace.gettingStarted.team.send": "Send invites ({count})",
  "workspace.gettingStarted.team.sending": "Sending…",
  "workspace.gettingStarted.team.result": "Invites sent: {sent}. Not sent: {failed}.",
  "workspace.gettingStarted.team.resultAll": "Invites sent: {sent}.",
  "workspace.gettingStarted.team.soonTitle": "Coming soon",
  "workspace.gettingStarted.team.soonHint": "Here you will invite the people from your site's team page.",
  "workspace.gettingStarted.team.deniedTitle": "Only workspace managers can see this",
  "workspace.gettingStarted.team.deniedHint": "Ask a manager of this workspace to invite your team.",
  "workspace.gettingStarted.team.errorTitle": "We could not load your team page",
  "workspace.gettingStarted.team.emptyTitle": "We found no names on your site",
  "workspace.gettingStarted.team.emptyHint": "Invite people by e-mail below.",
  "workspace.gettingStarted.errorHint": "Check your connection, then try again.",
  "workspace.gettingStarted.imports.title": "Import your data",
  "workspace.gettingStarted.imports.intro": "Bring rows from a file or another source into your apps. Every row keeps its source.",
  "workspace.gettingStarted.imports.sourcesTitle": "Other sources",
  "workspace.gettingStarted.imports.preview": "Preview",
  "workspace.gettingStarted.imports.previewAria": "Preview {name}",
  "workspace.gettingStarted.imports.uploadTitle": "Upload a file",
  "workspace.gettingStarted.imports.uploadHint": "CSV or Excel, up to 10 MB and 5,000 rows",
  "workspace.gettingStarted.imports.reading": "Reading the file…",
  "workspace.gettingStarted.imports.errUnsupported": "Only CSV and Excel files can be imported.",
  "workspace.gettingStarted.imports.errTooLarge": "This file is too large. The limit is 10 MB and 5,000 rows.",
  "workspace.gettingStarted.imports.errNoTable": "We found no table in this file.",
  "workspace.gettingStarted.imports.errPdfNotRead": "PDF tables are not read yet. Try a CSV or Excel file.",
  "workspace.gettingStarted.imports.errExpired": "This file expired. Upload it again.",
  "workspace.gettingStarted.imports.errSourceSoon": "This source is coming soon.",
  "workspace.gettingStarted.imports.errUnavailable": "Imports are not ready yet. Try again later.",
  "workspace.gettingStarted.imports.errFailed": "Something went wrong. Try again.",
  "workspace.gettingStarted.imports.soonTitle": "Coming soon",
  "workspace.gettingStarted.imports.soonHint": "Here you will bring rows from your files and other sources into your apps.",
  "workspace.gettingStarted.imports.deniedTitle": "Only workspace managers can see this",
  "workspace.gettingStarted.imports.deniedHint": "Ask a manager of this workspace to import your data.",
  "workspace.gettingStarted.imports.errorTitle": "We could not load this page",
  "workspace.gettingStarted.imports.rowCount": "Rows: {count}",
  "workspace.gettingStarted.imports.importInto": "Import into",
  "workspace.gettingStarted.imports.pickTarget": "Choose an app",
  "workspace.gettingStarted.imports.noTargets": "First install an app that can keep these rows.",
  "workspace.gettingStarted.imports.columnsAria": "Columns of this file",
  "workspace.gettingStarted.imports.fieldAria": "Field for the column {column}",
  "workspace.gettingStarted.imports.skip": "Skip this column",
  "workspace.gettingStarted.imports.required": "(required)",
  "workspace.gettingStarted.imports.newField": "Add as a new field",
  "workspace.gettingStarted.imports.needRequired": "Pick a column for every required field.",
  "workspace.gettingStarted.imports.needColumn": "Pick at least one column to import.",
  "workspace.gettingStarted.imports.run": "Import rows ({count})",
  "workspace.gettingStarted.imports.running": "Importing…",
  "workspace.gettingStarted.imports.done": "Added: {created}. Skipped: {skipped}. Failed: {failed}.",
  "workspace.gettingStarted.imports.pending": "The import goes on in the background. Its result shows here later.",
  "workspace.gettingStarted.imports.runFailed": "The import did not finish. Try again.",
  "workspace.gettingStarted.imports.undo": "Undo",
  "workspace.gettingStarted.imports.undoHint": "You can undo this import for 7 days.",
  "workspace.gettingStarted.imports.undoTitle": "Undo this import?",
  "workspace.gettingStarted.imports.undoMessage": "The rows it added are deleted from the app. Rows to delete: {created}. To bring them back, run the import again.",
  "workspace.gettingStarted.imports.undoConfirm": "Undo import",
  "workspace.gettingStarted.imports.undone": "The imported rows were removed.",
  "workspace.gettingStarted.imports.undoFailed": "We could not undo this import. Try again."
}
